// Menu/breadcrumb translation keys, scoped to what the common-apps components use.
// i18next format ({{var}} interpolation). Seeded from apps/ui/src/constants/strings.js.

import { sharedFeatures, sharedStrings } from '@cyberint/common-utils';

export default {
  productName: 'Exposure Management',
  cookieConsent: {
    essentialMessage:
      'We use essential cookies to keep our app secure and functioning properly. By using it, you accept their use.',
    accept: 'Got it',
    requiredMessage: 'Please accept essential cookies to use this application'
  },
  shared: sharedStrings,
  impersonation: {
    viewAs: 'View as %{customerName}',
    customerView: 'Customer view',
    actingAs: 'acting as %{customerName}',
    exitImpersonation: 'Exit to switch tenant',
    startError: 'Could not start impersonation. Please try again.',
    endError: 'Could not end impersonation. Please try again.'
  },
  maintenance: {
    sorry: "We're introducing a few upgrades!",
    apologize: 'We sincerely apologize for the inconvenience.',
    argos: 'Argos Edge',
    tm: 'TM',
    down_for_maintenance: ' is in read only mode and will be back soon.',
    down_for_maintenance_completely: 'will be back soon.',
    dont_worry: "Don't worry, collection and analysis are still running in the background.",
    questions: 'If you have any questions, feel free to contact our',
    contact_us: ' support',
    team: 'team'
  },
  webhook: {
    title: 'Webhook Configuration',
    status: 'Activate',
    failed_to_fetch_config: 'Failed to fetch Webhook configuration',
    saved_successfully: 'Webhook configuration saved successfully',
    failed_to_save: 'Failed to save Webhook configuration',
    invalidURL: 'Invalid URL',
    tokenNotFilled: 'Must have both Header key and Token value',
    url: 'URL',
    token: 'Token',
    webhookURLPlaceHolder: 'Insert Webhook URL',
    tokenPlaceHolder: 'Insert Token',
    save: 'Save',
    cancel: 'Cancel',
    headerKey: 'Token Header Name',
    headerKeyPlaceHolder: 'HTTP Header: <headerKey>:<token>',
    validateCertificate: 'Validate Server Certificate',
    includeToken: 'Include Token'
  },
  chatApp: {
    title: 'Chat Apps Notifications',
    telegram: 'Telegram',
    slack: 'Slack',
    teams: 'Microsoft Teams',
    invalidURL: 'Invalid URL',
    webhook_required: 'Webhook URL is required',
    webhookURL: 'Webhook URL',
    webhookUrlPlaceholder: 'Insert Webhook URL',
    updateValue: 'Update',
    save: 'Save',
    cancel: 'Cancel',
    chatId: 'Chat ID',
    token: 'Token',
    tokenPlaceholder: 'Insert Token',
    chatIdPlaceholder: 'Insert Telegram Chat ID',
    failed_to_fetch_config: 'Failed to fetch chat apps configuration',
    saved_successfully: 'Chat apps configuration saved successfully',
    failed_to_save: 'Failed to save chat apps configuration',
    deleted_successfully: 'Chat apps configuration deleted successfully',
    token_chat_must_exists: 'Must have both Chat ID and Token value',
    testConnection: 'Test Connection',
    sendTestMessage: 'Send Test Message',
    testModalDescription: "We'll send a test message to verify your chat app connection is working.",
    testMessageSent: 'Test message was sent, check your chat application',
    errorSendingTestMessage: 'Test message was not sent. Check your configuration and try again.'
  },
  whitelabel_settings: {
    save: 'Save',
    primary_main_color: 'Main Color',
    primary_main_color_desc: 'Set the main background color both on login page and adjustable screens',
    secondary_main_color: 'Secondary Color',
    secondary_main_color_desc: 'Set the secondary background color both on login page and adjustable screens',
    login_divider: 'Login Page divider',
    login_divider_desc: 'Set the color of the divider line in the login page',
    login_background_color: 'Login Button Background Color',
    login_background_color_desc: 'Set the color to the login button default background color',
    login_hover_color: 'Login Button Hover Color',
    login_hover_color_desc: 'Set the color to the login button when the cursor hovers over it',
    login_font_color: 'Login Button font Color',
    login_font_color_desc: "Set the color of the login button's font. It will be used both for default and hover",
    BigLogo: 'Primary Logo',
    BigLogo_desc: 'Set the login page logo',
    SmallLogo: 'Submark Logo',
    contactUs: '"Contact Us" URL',
    olh: 'Online Help',
    olh_desc: 'Set if the tenant will have Online Help',
    contactPlaceholder: 'Enter URL',
    invalidURL: 'Invalid URL',
    SmallLogo_desc: 'Set the application left pane logo while collapsed',
    failed_to_fetch_config: 'Failed to fetch whitelabel config',
    files: {
      drop_files: 'Drop files',
      drop_files_or_browse: 'Drop files or click to browse',
      failed_to_upload: 'Failed to upload files. Please try again.',
      exceeded_file_size: 'File size should not exceed 5MB',
      max_logo_count: 'You can upload up to %{count} logos'
    }
  },
  error: {
    'fetch-kb-entity': 'Failed to fetch knowledgebase entities',
    'failed-fetch-sectors': 'Failed to fetch sectors',
    'email-arleady-exists': 'Email already exists.',
    'email-is-invalid': 'Email is invalid.',
    'entity-already-exists': 'Entity already exists.',
    'folder-already-exists': 'Folder already exists.',
    'invalid-comma-separated-values': 'Invalid comma-separated values.',
    'invalid-name': 'Invalid Tenant name',
    'invalid-ip-range': 'Invalid IP range.',
    'check-user-and-password': 'Check your user and password',
    'url-is-invalid': 'URL is invalid.',
    '%{a}-cannot-be-empty': '%{a} cannot be empty.',
    '%{a}-should-be-lowercase': '%{a} must be lowercase.',
    '%{a}-already-exists': '%{a} already exists.',
    'invalid-number-of-types': 'Invalid number of types.',
    'password-confirmation-does-not-match': 'Password confirmation does not match.',
    'cannot-delete-assets': 'Cannot delete assets',
    'you-cannot-delete-company': 'You cannot delete company.',
    'error-occured': 'An error has occured: %{errorMessage}',
    'move-to-folder-dialog-warning': 'Please select only intel items, which relate to one customer.',
    'filters-required': 'Filters Required',
    'query-already-exists': 'Query already exists. Are you sure you want to overwrite %{queryName}?',
    publish_date_filter_not_support:
      'Custom Publish Date filter is not supported and will be ignored in the customized alert rule.',
    publish_date_filter_not_support_title: 'Custom Publish Filter is not supported',
    'too-many-results': 'Too many results. Please use a filter before exporting to CSV',
    'file-too-big-error': 'File is too big, max is %{maxFileSize}Kb',
    'at-least-one-search-source': 'Please select at least one search source.',
    'wrong-folder-name': 'Wrong folder name',
    'range-is-not-in-right-format':
      '"%{range}" is not in the right format. Please refer to the allowed formats syntax.',
    'ip-is-not-in-right-format': '"%{ip}" is not in the right format. Please refer to the allowed formats syntax.',
    'ip-is-private-please-enter-external': '"%{ip}" is a private address. Please enter external addresses only.',
    'the-range-is-too-big-please-decrease':
      'The range "%{range}" is too big, please decrease amount of addresses or split to different assets.',
    'failed-to-load-page': 'Looks like something went wrong. Please try again or head back to home page.',
    'invalid-page': 'Invalid or missing page. Please go back to previous page or head back to home page.',
    'unAuth-page':
      "Your current role doesn't include permission for this resource. Return home or ask your administrator for access.",
    'ref-id': 'Reference ID',
    oops: 'Oops..',
    'failed-to-load': 'Failed to load %{name}',
    unAuth: "You don't have access to this page",
    unSupported: 'Unsupported Page',
    'try-again': 'Try Again',
    'home-page': 'Home Page',
    'invalid-twitter-account': 'Please enter a valid Twitter ID',
    'date-format-iso': 'Date must be in ISO format (YYYY-MM-DD).',
    'new-version-detected': 'New version detected. Refreshing...',
    user_invitation_failure: 'Failed to send invitation to the user'
  },
  'save-query': {
    title: 'Save Query',
    title_recommended: 'Save Query for Recommended',
    title_template: 'Save Query as Template',
    query_name: 'Query name',
    queryName: 'Query name',
    queryNamePlaceholder: 'Add query name',
    createAsTemplate: 'Create as Template Query',
    templateWarning:
      'This action will publish the query to all users in the system.\nProceed only if the query is intended for organization-wide use.',
    warningCustomizedAlerts: 'Customized alerts are not supported for queries without textual parameters.',
    totalCount: 'result |||| results',
    deleteSuccess: 'The query was successfully deleted',
    deleteError: 'Something went wrong when trying to delete the query. Please try again',
    deleteQueryTitle: 'Delete Query',
    deleteQueryWarning: 'Deleting a query is irreversible, and will also delete the alert related to it. Are you sure?',
    confirmDeletion: 'Confirm Deletion',
    saveSuccess: 'The query was successfully saved',
    saveError: 'Something went wrong when trying to save the query. Please try again',
    errorCodes: {
      126: 'Looks like you are not allowed to perform this operation',
      127: 'The query cannot be saved as it exceeded the number of allowed saved queries',
      130: 'The name of the query is too long or invalid. Please change it and try again'
    },
    monitor: {
      title: 'Create customized alert rule',
      createCustomizedAlert: 'Customized Alert Based On Save Query Rule',
      createCustomizedAlertDesc:
        'Automate your saved query to get alerts when there are new intel items. The query will be continuously executed.',
      tooltip:
        'Automate your saved query to get alerts when there are new intel items. The query will be continuously executed.',
      confidence: 'Confidence',
      severity: 'Severity',
      description: 'Alert Description*',
      recommendation: 'Alert Recommendation*',
      descriptionPlaceholder:
        'Explain the query to the users consuming it, and the scenarios to which it applies. Note the non-targeted nature of the query, and the possible wide set of results that it may yield.',
      recommendations: 'Alert Recommendations',
      recommendationsPlaceholder:
        '\u2022 Verify the risk and impact of the finding on your organization.\n\u2022 Assign monitoring and research tasks to relevant parties and stakeholders.\n\u2022 Ongoingly finetune the query to narrow or broaden the set of results.',
      saveAndGenerate: 'Save & Generate',
      usedScope: 'Customized Alert Rule',
      alertRulesCapacityTitle: 'Alert Rules Capacity',
      totalTitle: 'Permitted',
      tooManyResultsWarning: 'The number of result is too large. Try to add filters or keyword to your search.',
      emptyFiltersOrKeyword: 'Enter at least one or more filters or keywords.',
      areYouSureTitle: 'Exit Save Query Monitor alerts?',
      areYouSureMessage: 'Your data will be lost when you leave this page.',
      yesExit: 'Yes, Exit'
    },
    monitoredSavedQuery: 'Customized Alert Rule',
    deactivateAlert: 'Deactivate Alert',
    deactivateAlertSuccess: 'Alert has been deactivated successfully',
    activateAlert: 'Activate Alert',
    activateAlertSuccess: 'Alert has been activated successfully'
  },
  updateQuery: {
    updateError: 'Failed to update the query, please try again later.',
    updateSuccess: 'The query’s filters were successfully updated.'
  },
  'generate-report': {
    title: 'Generate Report',
    'attached-screenshot': 'Attached Intel Item Screenshot',
    'description-placeholder': 'Enter Description',
    'save-generate': 'Save and Generate',
    'recommendations-placeholder': 'Enter Recommendations',
    'screenshot-form': {
      title: 'Edit Intel Item Screenshot',
      subtitle: 'You can scroll to reposition the screenshot and edit the content by deleting body text.'
    }
  },
  assets: {
    free: 'Free',
    important: 'Important',
    intelligence: 'Intelligence',
    normal: 'Normal',
    protection: 'Protection',
    secured: 'Secured',
    score: 'Score',
    similar: 'Similar',
    'add-asset': 'Add Asset',
    'add-%{name}': 'Add %{name}',
    'asset-type': 'Asset Type',
    'connected-to': 'Connected To',
    'first-name': 'First Name',
    'middle-names': 'Middle Names',
    'last-name': 'Last Name',
    'date-of-birth': 'Date Of Birth',
    'postal-code': 'Postal Code',
    'delete-assets': 'Delete Assets',
    'delete-selected': 'Delete Selected',
    'load-more': 'Load More',
    csv: 'CSV File',
    'search-restriction': 'Search Restriction',
    'search-sources': 'Search Sources',
    'code-repositories-github': 'GitHub',
    'code-repositories-postman': 'Postman',
    'social-media-youtube': 'YouTube',
    'social-media-twitter': 'Twitter',
    'search-engines-google': 'Google Dorks',
    'search-engines-grayhatwarfare': 'Open Buckets Database',
    'search-marketplace-ebay': 'EBay',
    'search-marketplace-malware-logs': 'Malware Log Shops',
    'search-appstore-official': 'Official App Stores',
    'search-appstore-third-party': '3rd Party App Stores',
    'update-asset': 'Update Asset',
    'ui-display': 'Display name',
    'custom-regex': 'Custom Regex',
    'filter-by-name': 'Enter asset name',
    'phishint-squatting': 'Monitor Look-alike Domains',
    'phishint-content': 'Monitor for Phishing Content',
    'phishint-content-brand': 'Monitor for Phishing Sites',
    'ip-address-and-range-format-examples': 'e.g. "1.2.3.4" or "1.2.3.4-1.2.3.10" or "1.2.0.0/16"',
    'list-of-ip-addresses-and-range-format-examples': 'e.g. "1.2.3.4, 1.2.3.0-1.2.3.10, 1.2.0.0/16"',
    'twitter-account-example': 'Enter a Twitter ID. e.g. "123456789"',
    'display-only': 'Display Only',
    all: 'All',
    error: {
      'limit-exceeded': 'System could not configure the asset as it exceeded scope',
      'public-email-provider': 'The domain is listed as a public email provider, and therefore it cannot be configured',
      'ip-part-of-cdn': 'The IP is listed as part of a CDN, and therefore it cannot be configured'
    }
  },
  auth: {
    'please-login': 'Sign in with email',
    welcome: 'Welcome',
    slogan: 'Impactful Intelligence',
    slogan_ng: 'Exposure Management',
    checkpoint_brand: 'Checkpoint',
    login: 'Login',
    mfa: 'Authentication Code (if applicable)',
    sign_in_with_different_user: 'Sign in with a different user',
    just_a_moment: 'Just a Moment',
    sign_in_text: 'We are signing you in to Argos Edge',
    reset_password: 'Reset Password'
  },
  termsAndConditions: {
    agree: 'I Agree',
    cancelAndLogout: 'Cancel and Logout',
    disabledConfirmTooltip: 'Read and click "I Agree" on the bottom of each tab to be able to Confirm',
    confirm: 'I agree to the Privacy Policy and Terms of Service',
    title: 'External Risk Management Terms & Conditions',
    privacy: 'Privacy Policy',
    terms: 'Terms of Service'
  },
  common: {
    underConstruction: 'Under Construction',
    underConstructionPage: ' Page is under construction',
    incidents: 'Cyber Attacks',
    threatActor: 'Threat Actor',
    malware: 'Malware',
    typeHere: 'Type here...',
    selected: 'Selected %{count}',
    exclude: 'exclude',
    include: 'include',
    all: 'All',
    noOptions: 'No options',
    searching: 'Searching..',
    min_search_text_length: 'Enter at least 3 characters',
    'exposure-management': 'Exposure Management',
    'assets-management': 'Assets Management',
    'last-three-months': 'Last three months',
    'intel-data-lake': 'Intelligence Data Lake',
    'invalid-customer': 'Invalid customer',
    impactometer: 'Impact-O-Meter',
    blast: 'BLAST',
    blastFindings: 'BLAST Findings',
    blastScans: 'BLAST Scans',
    need_help_question: 'Need Help?',
    reset_password: 'Reset Password',
    closePivot: 'Close Pivot',
    next: 'Next',
    back: 'Back',
    submit: 'Submit',
    confirm: 'Confirm',
    nextMonth: 'Next Month',
    prevMonth: 'Previous Month',
    entities: 'Entities & Assets',
    'lookalike-domain': 'Lookalike Domains',
    cve: 'CVE Intelligence',
    cve_ng: 'CVE Intelligence NG',
    iocManagement: 'IOC Management',
    iocExplorer: 'IOC Explorer',
    threatReadinessDashboard: 'Threat Readiness Dashboard',
    iocDetails: 'IOC Details',
    kb: 'Malware Intelligence',
    'malware-intel': 'Malware Intelligence',
    security_news: 'Cyber Security News',
    security_news_ng: 'Cyber Security News NG',
    cyber_news: 'Cyber News',
    threat_actors: 'Threat Actor Intelligence',
    campaigns: 'Campaign Intelligence',
    threat_landscape: 'Threat Landscape',
    bulletinBoard: '%{companyName} News Bulletin',
    'non-targeted-reporting': 'TI Stats',
    email: 'Email',
    language: 'Language',
    reports: 'Cyber Threat Reports',
    'not-set': 'Not Set',
    error: 'Error',
    edit: 'Edit',
    editFilters: 'Edit Filters',
    editSaveQuery: 'Edit Save Query',
    recommendations: 'Recommendations',
    password: 'Password',
    'are-you-sure': 'Are you sure?',
    apply: 'Apply',
    ok: 'OK',
    close: 'Close',
    cancel: 'Cancel',
    abort: 'Abort',
    continue: 'Continue',
    username: 'Username',
    description: 'Description',
    home: 'Home',
    settings: 'Settings',
    'my-account': 'Account Settings',
    ermSettings: 'Account Settings',
    'knowledge-base': 'Knowledge Base',
    knowledge_hub: 'Threat Knowledgebase',
    threatcloud_feed: 'ThreatCloud Intelligence Feed',
    dashboard: 'RI Dashboard',
    siem: 'SIEM Events',
    forensic: 'Forensic Canvas',
    'forensic-default-title': 'Forensic Canvas: Untitled Investigation',
    general: 'General',
    assets: 'Assets',
    'image-url': 'Image URL',
    value: 'Value',
    save: 'Save',
    add: 'Add',
    'add-new': 'Add new',
    'edit-item': 'Edit %{item}',
    customer: 'Customer',
    status: 'Status',
    remove: 'Remove',
    'remove-from-display': 'Remove from Display',
    'this-field': 'This field',
    title: 'Title',
    source: 'Source',
    'source-category': 'Source Category',
    untitled: 'Untitled',
    'not-found': 'Not Found',
    search: 'Search',
    nav_search_placeholder: 'Navigation Search...',
    nav_search_count: 'Showing %{match} of %{total} pages',
    nav_search_no_results: 'No pages found',
    nav_search_clear: 'Clear search',
    loading: 'Loading…',
    loadingByName: 'Loading %{name}…',
    url: 'URL',
    ip: 'IP',
    severity: 'Severity',
    confidence: 'Confidence',
    name: 'Name',
    date: 'Date',
    content: 'Content',
    clear: 'Clear',
    insert: 'Insert',
    'alert-type': 'Detection Type',
    'different-formats-supported':
      'Different formats supported, e.g. "2012-08-15T12:30:00", "2012-08-15", "now-1h", "1 sec ago"',
    author: 'Author',
    'author-image-url': 'Author image URL',
    'info-message': 'Info Message',
    'select-customer': 'Select customer',
    total: 'Total',
    'social-media': 'Social Media',
    'creation-date': 'Creation Date',
    'publish-date': 'Publish Date',
    created: 'Created',
    published: 'Published',
    'functionality-is-not-supported': '%{functionality} functionality is not supported for this item',
    comments: 'Comments',
    go: 'Go',
    indicator: 'Intel Item',
    like: 'Like',
    dislike: 'Dislike',
    'generate-report': 'Generate Report',
    'copy-indicator-to-clipboard': 'Copy Item ID',
    'export-to-csv': 'Export to CSV',
    'export-lookalike-domains': 'Export Lookalike Domains',
    'export-takedown-requests': 'Export Takedown Requests',
    'change-severity': 'Change Severity',
    'caasm-configuration': 'CAASM Configuration',
    open: 'Open',
    folders: 'Folders',
    'saved-queries': 'Saved Queries',
    filters: 'Filters',
    'filtered-view': 'Filtered View (Alpha)',
    'content-is-too-big-to-display': 'This intel item is too big to be shown',
    download_indicator: 'Download the content as a text file',
    download: 'Download',
    'download-file': 'Download File',
    'download-indicator-with-file': 'Download Intel Item Content With Attachment',
    'download-no-file': 'File isn\'t available in our storage, click "Go To URL" for direct download',
    active: 'Active',
    'not-active': 'Not Active',
    pending: 'Pending',
    removed: 'Removed',
    update: 'Update',
    labels: 'Labels',
    technique: 'Technique',
    country: 'Country',
    'ioc-feeds': 'IOC Feeds',
    none: 'None',
    websites: 'Websites',
    category: 'Category',
    read: 'Read',
    unread: 'Unread',
    keyword: 'Keyword',
    domain: 'Domain',
    unknown: 'Unknown',
    others: 'Others',
    'mark-as': '<span>Mark&nbsp;as %{name}</span>',
    'add-as': '<span>Add&nbsp;as %{name}</span>',
    official: 'Official',
    irrelevant: 'Irrelevant',
    done: 'Done',
    'attack-surface-monitoring': 'Attack Surface Monitoring',
    on: 'On',
    off: 'Off',
    'telegram-channel-view': 'Telegram Channel',
    'discord-channel-view': 'Discord Channel',
    'thread-channel-view': 'Thread View Channel',
    'vendor-inventory': 'Supply Chain Intel',
    'download-indicator': 'Download Intel Item',
    'download-indicator-content': 'Download Intel Item Content',
    'ti-events': 'Raw Intel',
    investigations: 'Analyst Investigations',
    leaked_credentials: 'Leaked Credentials',
    threats_emulation: 'Threat Emulation (Sandbox)',
    notifications: 'Notifications',
    panoptes: 'ThreatScope AI',
    auditLog: 'Audit Log',
    alerts: 'Alerts',
    alertsCenter: 'Alerts Center',
    threat_intelligence: 'Threat Intelligence',
    strategic_intelligence: 'Strategic Intelligence',
    digitalRiskProtection: 'Digital Risk Protection',
    threatHunting: 'Threat Intelligence',
    remediation: 'Remediation',
    exposure: 'Exposure',
    targeted_intel: 'Targeted Intel',
    threat_investigations: 'Threat Investigations',
    iocs: 'Indicators Of Compromise',
    integrations: 'Integrations',
    tem_integrations: 'TEM Integrations',
    integrations_hub_caasm_tab: 'CAASM',
    integrations_hub_tem_tab: 'TEM',
    integrations_hub_asm_tab: 'ASM',
    vulnerabilities: 'Vulnerabilities',
    vulnerability_remediation: 'Vulnerability Remediation',
    temDashboard: 'Threat Exposure Management',
    temSettings: 'TEM Settings',
    ioc_dissemination: 'IoC Dissemination',
    threatKb: 'Threat Knowledgebase',
    externalRisk: 'External Risk',
    dashboards: 'Dashboards',
    // New EM navigation labels
    action_center: 'Action Center',
    security_insights: 'Security Insights',
    remediations: 'Remediations',
    external_attack_surface: 'External Attack Surface',
    cyber_threat_intelligence: 'Cyber Threat Intelligence',
    targeted_intelligence: 'Targeted Intelligence',
    threat_investigation: 'Threat Investigation',
    reports_dashboards: 'Reports & Dashboards',
    external_risk_dashboard: 'External Risk Dashboard',
    strategic_dashboard: 'Strategic Dashboard',
    forensic_canvas: 'Forensic Canvas',
    darkweb_raw_intelligence: 'Darkweb Raw Intelligence',
    supply_chain_intelligence: 'Supply Chain Intelligence',
    live_org_attack_map: 'Live Attack Map',
    security_controls: 'Security Controls',
    cyber_news_attacks: 'Threat Activity',
    cyber_threat_reports: 'Cyber Threat Reports',
    ioc_management: 'IOC Dissemination',
    analyst_investigations: 'Analyst Investigations',
    credential_purchases: 'Credential Purchase',
    internal_exposure_overview: 'Internal Exposure Overview',
    vulnerability_prioritization: 'Vulnerability Remediation',
    cve_intelligence: 'CVE Intelligence',
    social_media_impersonation: 'Social Media Impersonation',
    takedowns: 'Takedowns',
    account_settings: 'Account Settings',
    tenants: 'Tenants',
    intelligence_data_lake: 'Intelligence Data Lake',
    operationalDashboard: 'Operational Dashboard',
    executiveDashboard: 'Strategic Dashboard',
    risk_dashboard: 'Risk Dashboard',
    env_summary: 'Env. Summary',
    automatedTakedown: 'Takedown Requests',
    credentialPurchased: 'Credentials Purchase Requests',
    smfp: 'Social Media Fake Pages',
    smfpLeg: 'Social Media Fake Pages (Legacy)',
    user_settings: 'User Settings',
    server_error: 'Oops! Something went wrong',
    please: 'Please',
    refresh_the_page: 'refresh the page.',
    please_contact_support: 'If the error persists, please contact',
    support: 'support.',
    reanalyze_indicator: 'Reanalyze Intel Item',
    reanalyze_indicators: 'Reanalyze Intel Items',
    create_alert: 'Create Alert',
    edit_alert: 'Edit Alert',
    clone_alert: 'Clone Alert',
    view_alert: 'View Alert',
    reanalyzed_single: 'The intel item was successfully sent to the analyzer',
    reanalyzed_plural: 'The intel items were successfully sent to the analyzer',
    reanalyze_failed_single: 'Something went wrong and we were unable to send the intel item to the analyzer',
    reanalyze_failed_plural: 'Something went wrong and we were unable to send the intel items to the analyzer',
    refresh: 'Refresh',
    new_version_available: 'A new Argos Edge version is now available.',
    create_another_alert: '+ Create Alert',
    view_alerts: 'View Alerts',
    invited: 'Invited',
    expired_invitation: 'Invitation expired',
    resend: 'Resend',
    invitationWasSent: 'Invitation was sent',
    resetPassword: 'Reset Password',
    resetPasswordWasSent: 'Password reset email was sent',
    userUpdateSuccess: 'User updated successfully',
    userUpdateFailure: 'Failed to update user',
    pendng_password_reset: 'Pending password reset',
    expired_reset_password: 'Password reset expired',
    yes: 'Yes',
    no: 'No',
    approve: 'Approve',
    undefined: 'Undefined',
    'noise-reduction': 'Noise Reduction',
    focused: 'Focused',
    powered_by: 'Powered by',
    optional: 'Optional',
    number_validation: {
      value_must_be_positive: 'Value must be positive',
      min_value: 'Minimum value is %{value}',
      max_value: 'Maximum value is %{value}'
    },
    generate: 'Generate QR Code',
    clickToCopy: 'Click to Copy',
    failedToCopy: 'Failed to copy to clipboard',
    copied: 'Copied!',
    created_date: 'Created Date',
    created_by: 'Created By',
    clear_filters: 'Clear Filters'
  },
  dashboard: {
    'reputation-feeds': 'Reputation Feeds',
    'now-scanning': 'Now Scanning',
    'alerts-by-type': 'Alerts by Type',
    'trends-by-week': 'Trends by Week',
    domains: 'Domains',
    'total-domains': 'Total Assets',
    ips: 'IPs',
    'total-ips': 'Total Assets',
    websites: 'Websites',
    'total-websites': 'Total Websites',
    'threat-intel': 'Threat Intelligence',
    'social-networks': 'Social Networks'
  },
  folders: {
    'my-area': 'My Area',
    'delete-folder': 'Delete Folder',
    'new-folder': 'New Folder',
    'folder-name': 'Folder name',
    'the-folder-will-be-removed...': 'The folder %{name} will be removed. Are you sure?',
    'the-folder-and-its-sub-folders...': 'The folder %{name} and its sub-folders will be removed. Are you sure?',
    'folder-already-exists-in-removed': 'Folder with name "%{name}" already exists in removed folder.',
    'add-new-folder': 'Add a new folder',
    'rename-folder': 'Rename folder',
    'move-folder-to-removed': 'Move folder to Removed'
  },
  filters: {
    'filter-by': 'Filter By',
    type: 'Type',
    'free-text': 'Search',
    all: 'All',
    from: 'From',
    to: 'To',
    'time-to-time': '%{from} to %{to}',
    'select-time-range': 'Select Time Range',
    'type-something': 'Type something',
    'no-results-found': 'No results found',
    'results-found': '%{amount} results found for:',
    loading: 'Loading...',
    tool: 'Tool',
    'threat-actor': 'Threat actor',
    campaign: 'Campaign',
    'observation-date': 'Observation date',
    classification: 'Classification',
    'tool-detected': 'Tool detected',
    country: 'Country',
    'pick-range': 'Custom Range',
    'quick-view': 'Queries',
    'quick-view-subtitle': 'Choose a query to apply filters',
    'add-queries': 'Add Queries',
    'find-queries': 'Find Queries',
    'filter-ti-events': 'FILTER ITEMS',
    'search-ti-events-placeholder': 'Search items',
    'exceeds-date-range-error': 'The selected range exceeds the maximum of %{days} days',
    'invalid-date-range-error': 'Invalid date range',
    'free-text-filter-tooltip': {
      header: {
        operation: 'Operation',
        operator: 'Operator',
        example: 'Example'
      },
      description: 'Optimize the search of Intelligence Items by utilizing the operators provided below.'
    }
  },
  entities: {
    'no-entities': 'No Entities'
  },
  saved_queries: {
    queries: 'Queries',
    filters: 'Filters',
    back_to_queries: 'Back to Queries',
    recommended_queries: 'Recommended queries',
    custom_queries: 'Custom queries',
    save_for_recommended: 'Save for Recommended',
    save_as_template: 'Save as Template',
    my_queries: 'My Queries',
    set_new_queries: 'Set New Queries',
    alert_queries: 'Alert Queries',
    templates: 'Templates',
    environment_queries: 'Environment Queries',
    add_to_my_queries: 'Add to My Queries',
    addedToMyQueriesSuccess: 'Query has been added to My Queries',
    copy_to_my_queries: 'Copy to My Queries',
    edit_query_name: 'Edit Query Name',
    edit_template_filters: 'Edit Filters',
    delete_template: 'Delete Template',
    delete_template_warning:
      'Deleting a template is irreversible, and will also delete the alert related to it. Are you sure?',
    delete_template_success: 'Template was successfully deleted',
    delete_template_error: 'Something went wrong when trying to delete the template. Please try again',
    edit_template_name_success: 'Template name was successfully updated',
    unpin_query: 'Unpin Query',
    unpinSuccess: 'Query has been unpinned from My Queries',
    unpinError: 'Failed to unpin query',
    tooltip_created_date: 'Created date',
    save_new_query: 'Save New Query'
  },
  'threat-data': {
    'no-threat-data': 'No Threat Data',
    'threat-data-info': 'Threat Data: %{threatsStr}',
    'threats-caught': 'Threat Caught |||| Threats Caught',
    'rbl-servers': 'RBL Server |||| RBL Servers',
    'social-defacement': 'Social Account Defacement',
    'likes-amount': 'Page # of Likes: %{numOfLikes}',
    'post-type': 'Post Type: %{postType}',
    'page-url': 'Page URL: %{pageUrl}',
    'content-url': '%{content_type} URL: %{url}',
    'negative-content-caught': 'Negative Content Caught: %{content}',
    'malicious-content-caught': 'Malicious Content Caught: %{content}',
    cves: 'CVE(s)',
    'vulnerability-summary': 'Vulnerability Summary',
    'view-image': 'View Image',
    'no-image': 'No image available',
    'website-screenshot': 'Website Screenshot'
  },
  indicators: {
    post: 'Post',
    comment: 'Comment',
    highlight: 'Hightlight',
    'open-entity-page': 'Open entity page',
    original: 'Original',
    translation: 'Translation',
    'no-labels': 'No labels',
    recommendations: "Cyberint's Recommendations",
    'alert-issued': 'Alert Issued',
    repository_name: 'Repository Name',
    author_email_address: 'Author Email Address',
    file_name: 'File Name',
    method: 'Method',
    url: 'URL',
    name: 'Name',
    workspace: 'Workspace',
    collection: 'Collection',
    description: 'Description',
    headers: 'Headers',
    auth: 'Authentication',
    environment_variables: 'Environment Variables',
    request_details: 'Request Details',
    request_body: 'Request Body',
    pre_script: 'Pre Script',
    post_script: 'Post Script',
    responses: 'Responses',
    repository_discovery_method: 'Repository Discovery Method',
    original_indicator_id: 'Original Intel Item ID',
    original_matched_assets: 'Original Matched Assets',
    'loading-data': 'Loading data...',
    'loading-data-failed': 'Could not load data.'
  },
  recommendation: {
    'phishing-google-report':
      "Report to Google this is a phishing site. You can also request the site's takedown by Cyberint",
    'modal-phishing-message': 'Clicking OK will report this website to Google Safe Browsing. Are you sure?',
    'modal-irrelevant-message': 'Clicking OK will delete this alert and the asset. Are you sure?',
    'modal-official-message': 'Are you sure you want to add the website at %{url} as an official site?',

    'modal-phishing-final': 'Thank you.\nWe are sending your report to Google',
    'modal-irrelevant-final': 'Thank you.\nThe asset was deleted and the alert was removed',
    'modal-official-final': 'Thank you.\nThe website was added as an official site'
  },
  alerts: {
    'ip-rbl': 'IP in Blacklist',
    'ip-bot': 'Botnet Detection',
    'ip-bot-alert-tube': 'Botnet\nDetection',
    'ip-cnc': 'C&C Detection',
    'page-name': 'Page Name',
    defacement: 'Defacement',
    'social-defacement': 'Social Account Defacement',
    'leaked-creds': 'Leaked Credentials',
    'leaked-creds-alert-tube': 'Leaked\nCredentials',
    'js-scanner': 'JS Scanner',
    'js-new-code': 'JS New Content',
    'js-code-change': 'JS Code Change',
    'js-vulnerabilities': 'JS Vulnerabilities',
    'js-malicious': 'Malicious JS',
    phishing: 'Phishing',
    malicious: 'Malicious Comments',
    'nc-hashtag': 'Hashtag Found',
    'nc-blacklist': 'Blacklisted Words',
    'nc-url': 'URL Found',
    'broken-url': 'Broken URL',
    spf: 'SPF Issues',
    'spf-dashboard': 'SPF Record',
    'spf-weak': 'Misconfigured SPF Record',
    'spf-missing': 'Missing SPF Record',
    'insecure-open-ports': 'Potentially Exploitable Ports',
    'negative-content': 'Negative Content',
    'open-ports': 'Potentially Exploitable Ports',
    'open-ports-alert-tube': 'Potentially\nExploitable Ports',
    'open-ports-title': 'Open sensitive ports were detected for %{ip}',
    'open-ports-description':
      'An attacker will often initially perform reconnaissance, and scan externally the organization, to figure out which ports are open. Open ports are vulnerable, and can be a risk to the organization. Attackers can exploit these open ports for their malicious objectives.',
    'spf-missing-title': 'No SPF record found for %{domain}',
    'spf-weak-title': 'Found misconfigured SPF record for %{domain}: %{record}',
    'spf-description':
      "Sender Policy Framework (SPF) is a simple email-validation system designed to detect email spoofing by providing a mechanism to allow receiving mail exchangers to check that incoming mail from a domain comes from a host authorized by that domain's administrators.",
    'phishing-alert': {
      description: 'A possible phishing site detected at %{url}',
      title: 'Analysis Findings:',
      logo: 'Logo similar to %{business_asset}\'s logo was detected: <img src="%{logo_attachment_url}" class="%{logo_class_name}">',
      page_source: "Assets were detected in the suspicious site's source code:"
    },
    'title-templates': {
      phishing: {
        plain: 'Possible phishing site detected at %{asset_name}',
        strong: 'Possible&nbsp;<strong>phishing site</strong>&nbsp;detected at&nbsp;<strong>%{asset_name}</strong>'
      },
      'negative-content': {
        plain: 'Negative content detected on %{asset_name}',
        strong: '<strong>Negative content</strong>&nbsp;detected on&nbsp;<strong>%{asset_name}</strong>'
      },
      'js-malicious': {
        plain: 'Malicious JavaScript code detected on %{asset_name}',
        strong: '<strong>Malicious JavaScript</strong>&nbsp;code detected on&nbsp;<strong>%{asset_name}</strong>'
      },
      'url-malicious': {
        plain: 'Malicious URL detected on %{asset_name}',
        strong: '<strong>Malicious URL</strong>&nbsp;detected on&nbsp;<strong>%{asset_name}</strong>'
      },
      'js-vulnerability': {
        plain: 'JavaScript vulnerability detected in a resource on %{asset_name}',
        strong:
          '<strong>JavaScript vulnerability</strong>&nbsp;detected in a resource on&nbsp;<strong>%{asset_name}</strong>'
      },
      'ip-rbl': {
        plain: 'Blacklisted IP listed on %{content}: %{url}',
        strong: '<strong>Blacklisted IP</strong>&nbsp;listed on %{content}:&nbsp;<strong>%{url}</strong>'
      },
      'social-defacement': {
        plain: 'Possible social account defacement detected on %{asset_name}',
        strong:
          'Possible&nbsp;<strong>social account defacement</strong>&nbsp;detected on&nbsp;<strong>%{asset_name}</strong>'
      },
      defacement: {
        plain: 'Possible defacement detected on %{asset_name}',
        strong: 'Possible&nbsp;<strong>defacement</strong>&nbsp;detected on&nbsp;<strong>%{asset_name}</strong>'
      },
      discovered: {
        plain: 'Community page found for %{asset_name}',
        strong: '<strong>Community page</strong>&nbsp;found for&nbsp;<strong>%{asset_name}</strong>'
      },
      spf: {
        plain: 'Spoofing susceptibility found for domain %{url}',
        strong: '<strong>Spoofing susceptibility</strong>&nbsp;found for domain&nbsp;<strong>%{url}</strong>'
      },
      'ip-cnc': {
        plain: 'Possible C&C server was detected for %{url}',
        strong: 'Possible&nbsp;<strong>C&amp;C server</strong>&nbsp;was detected for&nbsp;<strong>%{url}</strong>'
      },
      'ip-bot': {
        plain: 'Possible botnet was detected for %{url}',
        strong: 'Possible&nbsp;<strong>botnet</strong>&nbsp;was detected for&nbsp;<strong>%{url}</strong>'
      },
      'insecure-open-ports': {
        plain: 'Exploitable ports were found for %{url}',
        strong: '<strong>Exploitable ports</strong>&nbsp;were found for&nbsp;<strong>%{url}</strong>'
      },
      'js-content-changed': {
        plain: 'JavaScript code change detected on %{asset_name}',
        strong: '<strong>JavaScript code change</strong>&nbsp;detected on&nbsp;<strong>%{asset_name}</strong>'
      },
      'js-new-content': {
        plain: 'Additional JavaScript library detected on %{asset_name}',
        strong: '<strong>Additional JavaScript library</strong>&nbsp;detected on&nbsp;<strong>%{asset_name}</strong>'
      },
      'broken-url': {
        plain: 'Broken links detected on %{asset_name}',
        strong: '<strong>Broken links</strong>&nbsp;detected on&nbsp;<strong>%{asset_name}</strong>'
      },
      'leaked-creds': {
        plain: 'Leaked credentials found for %{asset_name}',
        strong: '<strong>Leaked credentials</strong>&nbsp;found for&nbsp;<strong>%{asset_name}</strong>'
      }
    }
  },
  source: {
    feeds: 'Feeds',
    'leaked-db': 'Leaked DB'
  },
  'home-page': {
    'select-folder': 'Select Folder',
    'remove-indicators': 'Remove Intel Items',
    'move-to': 'Move To',
    toolbar: {
      open: 'Open'
    },
    'new-indicators': 'New Intel Items!',
    'pause-monitoring-for...': 'Pause monitoring for new intel items',
    'ai-summary': {
      'failed-enrichment': 'Failed summarizing intel item',
      title: 'AI-assisted Summary',
      ok: 'Ok'
    }
  },
  cyclops: {
    'data-enrichment': 'Data Enrichment',
    'email-query': 'Email Query',
    'risk-scores': 'Risk Scores',
    'risk-cards': 'Risk Cards',
    'saved-query': 'Queries',
    search: 'CAASM Insights',
    dashboards: 'CAASM Dashboards',
    integrations: 'CAASM Integrations',
    asm_integrations: 'ASM Integrations',
    'internal-asm': 'Internal Attack Surface',
    configuration: 'CAASM Configuration'
  },
  'my-account': {
    phishing_beacon_configuration: 'Phishing Beacon Configuration',
    phishing_beacon_tester: 'Phishing Beacon Tester',
    whitelabel_settings: 'WhiteLabel Theme Settings',
    sso_config: 'SSO Configuration',
    'asm-configuration': 'ASM Configuration',
    'license-management': 'License Management',
    'my-assets': 'My Assets',
    customers: 'Tenants',
    'add-customer': 'Add Tenant',
    'convert-customer': 'Convert Tenant Type',
    'parent-customers': 'MSSP Parent',
    'environment-type': 'Environment Type',
    environment_type_description:
      'The environment type defines the purpose of the tenant.\n\n* Production tenants are used for customers under contract.\n\n* POC tenants are used for proof of concepts and include all of Argos capabilities.\n\nThe tenant should be removed once POC is completed.',
    environment_url: 'Environment URL',
    environment_url_description: 'The Environment URL is the URL used to access the specific tenant.',
    'account-type': 'Account Type',
    'tenant-type': 'Tenant Type',
    engagement_type: 'Engagement Type',
    browse: 'Browse',
    'insert-indicator': 'Insert Intel Item',
    'my-profile': 'My Profile',
    'user-management': 'User Management',
    'view-customer': 'View Tenant',
    'disable-customer': 'Disable Tenant',
    'restore-customer': 'Restore Tenant',
    'remove-customer': 'Remove Tenant',
    'customer-and-its-assets-will-be-disabled': 'The tenant %{customer} and its assets will be disabled. Are you sure?',
    'customer-and-its-assets-will-be-restored': 'The tenant %{customer} and its assets will be restored. Are you sure?',
    'invite-users': 'Invite Users',
    'cybering-domain-placeholder': 'Value must be a valid Cyberint domain',
    'timezone-type': 'Time Zone',
    max_active_user_limit: {
      null: 'Unlimited'
    },
    maxActiveUserLimit: {
      unlimited: 'Unlimited',
      label: 'Max active user limit',
      failedCreateUserLimitConfig: 'Failed to update the user limit, please refresh the page and try again.',
      successCreateUserLimitConfig: 'User limit updated successfully.'
    },
    targetArea: {
      sectors: 'Sectors',
      countries: 'Countries',
      errorMsg: {
        failedFetchCustomerConfig: 'Failed to fetch customer details configuration'
      }
    },
    environment_type: {
      poc: 'POC',
      production: 'Production',
      demo: 'Demo',
      internal: 'Internal',
      prospect: 'Prospect'
    },
    account_type: {
      managed_service: 'Managed Service',
      mssp_managed_service: 'MSSP-Managed Service',
      mssp: 'MSSP',
      self_service: 'Self Service',
      hybrid_service: 'Hybrid Service'
    },
    'modal-notification': {
      '2FA': {
        title: 'Set Whitelisted IPs',
        content:
          'To avoid login issues, please make sure the IP of the user is configured correctly or alternatively, the range 0.0.0.0/0 is whitelisted to allow users to log in from any machine.'
      }
    },
    'general-page': {
      'clear-environment': 'Clear Environment',
      'clear-environment-modal': {
        title: 'Remove Environment Data',
        message: "All prospect's items will be removed from environment",
        success: 'Cleared environment successfully',
        failure: 'Failed to clear environment, running this operation multiple times can solve the issue!'
      }
    },
    'sso-configurations': {
      title: 'SSO Configuration',
      client_id: 'Client ID',
      configuration_url: 'Metadata URL',
      custom_url: 'Custom Metadata URL',
      initiate_login_uri: 'Initiate login URI',
      signin_redirect_uri: 'Sign-in redirect URI',
      failed_to_fetch: 'Failed to fetch SSO configuration',
      client_secret: 'Client Secret',
      metadata_url: 'Metadata URL',
      provider: 'Provider',
      okta: 'Okta',
      google: 'Google Workspace',
      azure: 'Azure AD',
      one_login: 'OneLogin',
      custom: 'Custom',
      response_type: 'Flow Type',
      implicit_flow: 'Implicit Flow (Default)',
      code_flow: 'Code Flow',
      token_endpoint_auth_method: 'Token Endpoint Authentication Type',
      none: 'Public (None PKCE)',
      client_secret_post: 'Client Secret Post',
      client_secret_basic: 'Client Secret Basic',
      one_login_subdomain: 'OneLogin Customer Subdomain ID',
      okta_customer_domain: 'OKTA Customer Domain',
      directory_tenant_id: 'Directory/Tenant ID',
      fill_all_fields: 'Please fill in all the required fields',
      test_connection: 'Test and Save',
      clear: 'Clear SSO Settings',
      clearSSOConfig: 'Clear SSO Configuration',
      are_u_sure_clear_question: 'Are you sure you want to clear the SSO Configuration?',
      successUpdate: 'SSO configuration updated',
      failedUpdate: 'Failed to update SSO configuration',
      test_success: 'Test succeeded',
      test_fail: 'Test failed',
      provider_not_configured: 'Provider is currently not supported',
      enabled: 'Enabled',
      disabled: 'Disabled',
      loading: 'Loading...',
      disabled_message:
        'To use SSO to connect to the platform, please enable the configuration and insert the required fields.',
      save_config: 'Save Configuration',
      save_config_question:
        'Configuration for this provider was found. Make sure the details are correct before saving and enforcing SSO for all users.',
      save: 'Save',
      cancel: 'Cancel',
      enforcement_modal_title: 'SSO Configuration Saved',
      enforcement_modal_intro:
        'Your SSO configuration has been saved successfully! You can now manage SSO enforcement for users.',
      enforcement_modal_description:
        'Go to User Management to configure which users should use SSO for authentication, or continue working and set this up later.',
      enforcement_go_to_users: 'Go to User Management',
      enforcement_later: 'Later',
      enforcement_success: 'Successfully enforced SSO for %{count} users',
      enforcement_partial_success: 'Enforced SSO for %{successCount} users, but %{errorCount} failed',
      enforcement_failed: 'Failed to fetch users or enforce SSO'
    },
    'filtered-view': {
      title: 'Filtered View (Alpha)',
      page_title: 'Filtered View Configuration',
      page_subtitle: 'Tune what gets hidden (noise reduction) and what gets surfaced (focused view) for this tenant.',
      commentPlaceholder: 'Enter your comment here',
      to_exclude: 'The following will be excluded from your view:',
      to_highlight: 'The following will be focused into view:',
      exclude_title: 'Noise reduction',
      exclude_subtitle: 'Items matching these rules are hidden from your queue.',
      exclude_chip: 'Excluded',
      highlight_title: 'Focused view',
      highlight_subtitle: 'Items matching these rules are surfaced first.',
      highlight_chip: 'Highlighted',
      'request-error-msg': {
        failedCustomerConfig: 'Failed to load configuration, please refresh the page.',
        failedCreateAlertConfig: 'Failed to update alert configuration, please refresh the page and try again.',
        failedUpdateAlertConfig: 'Failed to update alert configuration, please refresh the page and try again.'
      },
      'request-success-msg': {
        successCreateAlertConfig: 'Configuration has been updated successfully.',
        successUpdateAlertConfig: 'Configuration has been updated successfully.'
      },
      fields: {
        'indicator-author': 'Author',
        'indicator-source': 'Source',
        'indicator-category': 'Source Category',
        'indicator-title': 'Title',
        'indicator-content': 'Content',
        'labels-entity_id': 'Category',
        'indicator-found_entities-entity_id': 'Customer Assets',
        'indicator-found_entities-type_id': 'Customer Asset Type',
        'indicator-found_entities-entity_id_all': 'Shared Assets'
      },
      operators: {
        equal: 'equals',
        not_equal: 'does not equal',
        like: 'contains',
        not_like: 'does not contain',
        is_empty: 'is empty',
        is_not_empty: 'is not empty',
        multiselect_equals: 'is any of',
        multiselect_not_equals: 'is none of',
        select_any_in: 'is any of (legacy)',
        select_not_any_in: 'is none of (legacy)',
        asset_exclusive: 'appears alone'
      },
      deleteGroupAria: 'Delete group',
      expandGroupAria: 'Expand group',
      deleteRuleAria: 'Delete rule',
      analyzer: {
        title: 'AI Analyzer',
        subtitle: 'Audit the current Filtered View, surface noisy rules, and apply structural fixes locally.',
        headline: 'Audit your rule set',
        tagline: 'Scans your filtered view for noise:',
        'bullet-redundant': 'Redundant or overlapping rules',
        'bullet-contradictions': 'Contradictions',
        'bullet-overlybroad': 'Overly broad filters',
        'bullet-dead': 'Dead branches',
        'bullet-suggest': 'Suggests new rules from environment activity',
        eta: 'Takes about 10 minutes',
        'keep-editing-hint': 'You can keep editing — results will reflect the snapshot taken at scan start.',
        'clean-result': 'No issues detected. Your rule set looks clean.',
        'findings-badge': '%{count} findings',
        reanalyze: 'Re-analyze',
        analyze: 'Analyze rules',
        cancel: 'Cancel scan',
        analyzing: 'Analyzing rules…',
        cost: 'cost',
        dirtyWarning: 'You have unsaved changes. The analyzer runs against the saved configuration.',
        emptyFindings: 'No findings yet.',
        emptySuggestions: 'No suggestions yet.',
        findings: 'Findings (%{count})',
        suggestions: 'Suggestions (%{count})',
        findingsHeader: 'Findings',
        suggestionsHeader: 'Suggestions',
        summaryHeader: 'Audit summary',
        turns: 'turns',
        statusStarting: 'Starting analysis…',
        statusFinished: 'Analysis finished — %{findings} findings, %{suggestions} suggestions.',
        connectionError: 'Connection to analyzer lost.',
        connectionLost: 'connection lost',
        loadFailed: 'load failed',
        startFailed: 'start failed',
        hydrateFailed: 'hydrate failed',
        noRunIdFromServer: 'no run_id from server',
        historyMeta: '%{status} · %{findings} findings / %{suggestions} suggestions',
        collapseAria: 'Collapse analyzer',
        impacted: 'Impacts %{count} items',
        apply: 'Apply locally',
        applied: 'Applied',
        appliedAt: 'Applied %{ts}',
        revert: 'Revert',
        applyFailed: 'Could not apply suggestion: %{reason}',
        applySuccess: 'Suggestion applied. Save to persist.',
        ruleMissing: 'Target rule no longer exists in the tree.',
        unsupportedOp: 'Unsupported operation: %{op}',
        failedNotice: 'This run stopped early — the analyzer did not respond for 15 minutes.',
        cancelledNotice: 'This run was cancelled before completing.',
        historyLabel: 'Run',
        historyMenu: 'Recent reports',
        historyBy: 'by %{user}',
        historyDuration: '%{duration}',
        historyRunning: 'running',
        historyUnknownUser: 'unknown user',
        historyStale: 'Stale',
        staleNotice: 'This report is over a week old. Re-run for fresh insights.',
        showDismissed: 'Show dismissed (%{count})',
        hideDismissed: 'Hide dismissed (%{count})',
        ranAt: 'Ran %{ts}',
        explainerShow: 'What does this do?',
        explainerHide: 'Hide explanation',
        runStatus: {
          idle: 'Not run',
          running: 'Running',
          done: 'Done',
          error: 'Error',
          failed: 'Failed',
          cancelled: 'Cancelled'
        },
        severity: {
          critical: 'Critical',
          high: 'High',
          medium: 'Medium',
          low: 'Low',
          info: 'Info'
        },
        ops: {
          remove_rule: 'Remove rule',
          tighten_rule: 'Tighten rule',
          set_comment: 'Update comment',
          add_rule: 'Add rule',
          move_rule: 'Move rule',
          update_rule: 'Update rule',
          update_rule_value: 'Update rule value',
          set_conjunction: 'Change AND/OR',
          set_value: 'Update value'
        }
      },
      'apply-disabled-tooltip': 'No changes to save',
      'apply-invalid-tooltip': 'Fix invalid rules and empty groups before saving',
      'preview-exclude': 'Preview — items will be hidden when',
      'preview-highlight': 'Preview — items will be surfaced when',
      'unsaved-badge': 'Unsaved',
      'export-config': 'Export',
      'import-config': 'Import',
      'import-error': 'Invalid configuration file.',
      'import-success': 'Configuration imported. Save to persist.',
      fieldPlaceholder: 'Field',
      operatorPlaceholder: 'Operator',
      valuePlaceholder: 'Select',
      negateGroup: 'Negate group',
      addNote: '+ Add note',
      commentShortcutHint: '⌘+Enter to save · Esc to cancel',
      findingInGroupTitle: 'Analyzer finding inside this group',
      findingBadge: 'Finding',
      rulesHiddenSingular: '%{count} rule hidden — click to expand',
      rulesHiddenPlural: '%{count} rules hidden — click to expand',
      emptyGroup: 'No rules yet. Add a rule or a nested group to get started.',
      addRule: '+ Add rule',
      addNestedGroup: '+ Add nested group',
      ruleCountSingular: '%{count} rule',
      ruleCountPlural: '%{count} rules'
    },
    'alert-configurations': {
      title: 'Targeted Alerts',
      configuration: 'Targeted Alerts Configuration',
      webhook_title: 'Webhook',
      custom_notifications_title: 'Notifications',
      integrations_title: 'AD integrations',
      access_logs_integrations_title: 'Access Logs',
      categories: 'Categories',
      automaticTitle: 'Alert Configuration',
      force_all_alerts_in_review_label: 'Force all alerts to "In Review"',
      force_all_alerts_in_review_description:
        'When enabled, all automatic alerts for this tenant are created in "In Review" and are never auto-published.',
      force_all_alerts_in_review_requires_policy:
        'Select an alert policy first — this option becomes available once an alert configuration exists for the tenant.',
      global_policy_modal: {
        title: 'Policy Change Impact',
        content:
          'You are about to change the global alert policy for your tenant.\nPlease be aware that this change will affect the configuration of multiple alert types and settings across your environment.\nThese changes may impact how alerts are triggered, reviewed, and processed.\n\nAre you sure you want to proceed with this policy change?'
      },
      subtype_policy_modal: {
        title: 'Policy Change Impact',
        content:
          "You are about to change this alert's policy for your tenant.\nPlease be aware that this change will affect the configurations of this alert type and settings across all created alerts of this type.\nThese changes may impact how alerts are triggered, reviewed, and processed.\n\nAre you sure you want to proceed with this policy change?"
      },
      config_policy: {
        optimized: 'Optimized',
        managed_optimized: 'Optimized',
        provisioning_optimized: 'Optimized',
        true_label: {
          optimized: 'Self Service Optimized',
          managed_optimized: 'Managed Service Optimized',
          provisioning_optimized: 'Provisioning Optimized',
          strict: 'Strict',
          light: 'Light'
        },
        light: 'Light',
        strict: 'Strict',
        customized: 'Customized',
        tooltip: {
          optimized:
            'The alert configuration determines the confidence level at which alerts will be published.\nThe Optimized policy includes a set of confidence levels and settings for each alert sub-type to strike the best balance between ensuring critical alerts are published and not missed, while maintaining a low false positive rate.\nThis policy is the result of research and optimization cycles based on the most common client use cases.',
          light:
            'The alert configuration determines the confidence level at which alerts will be published.\nThe Light policy includes a set of confidence levels and settings for each alert sub-type.\nWhile this policy minimizes the chance of misdetection, it requires manual review to validate the alerts, ensuring false positives are caught and handling high-volume alerts with a high level of quality.',
          strict:
            'The alert configuration determines the confidence level at which alerts will be published.\nThe Strict policy uses a set of confidence levels and settings for each alert sub-type to minimize false positives.\nThis policy is recommended if your organization has limited capacity for manual review and prefers to keep the false positive rate to a minimum.'
        },
        subtype_activation_modified: "The alert's disable/enable setting was manually modified."
      },
      manually_customized: 'Manually Customized',
      global_policy: 'Global Policy',
      unset: 'Unset',
      no_global_policy: 'No Global Policy has been set yet',
      customized_policy: '%{policyType} policy with customized settings.',
      policy_type: '%{policyType} policy',
      alert_subtype: 'Alert Sub-Type',
      form: {
        all: 'All',
        remote_exploitation: 'Remote Only',
        epss_percentile_threshold: 'EPSS Percentile Threshold',
        epss_percentile_threshold_tooltip:
          "Ranks a vulnerability's likelihood of exploitation compared to all other known vulnerabilities",
        activate_auto_alert: 'Activate Automatic Alert',
        system_default: 'System default',
        true: 'Yes',
        false: 'No',
        malware_log_validity_period_days: 'Malware logs Publish date Limitation',
        pw_reset: 'Reset Password',
        pw_reset_tooltip: 'Activate Reset Password Automation Via Playblocks Integration',
        pw_reset_admin_approval: 'Admin Approval',
        pw_reset_admin_approval_tooltip: 'Require Admin Approval to Reset Password',
        failed_to_fetch_playblocks_config: 'Failed to fetch playblocks configuration',
        failed_to_update_pw_reset: 'Failed to update password reset configuration',
        pw_reset_update_delay: 'This change will apply within 5 minutes',
        other_sources_validity_period_days: 'Other sources Publish date Limitation',
        confidence_threshold: 'Confidence Threshold',
        confidence_threshold_force_in_review_tooltip:
          'Confidence thresholds are irrelevant while "Force all alerts to In Review" is enabled — every alert is created in review regardless of confidence.',
        fallbackMsg:
          "Targeted Intelligence Configuration enables tuning of alerts by overriding the alert's default configurations and customizing specific parameters.\nPlease select an alert type to configure an alert.",
        unlicensedMsg: 'Targeted Intelligence Configuration is not licensed',
        selected_profile: 'Selected Profile',
        apply: 'Apply',
        passwordPolicy: 'Password Policy',
        minimum_similarity_rate: 'Minimum Similarity Rate',
        severity_override: 'Severity Override',
        excluded_email_domains: 'Excluded Email Domains',
        excluded_email_domains_tooltip: 'Prevent excluded domains from being treated as corporate users',
        excluded_hostnames: 'Excluded Hostnames',
        excluded_hostnames_ph: '*.domain.com | domain.co.il',
        excluded_hostnames_phishing_tooltip: 'Prevent excluded domains from creating phishing alerts',
        excluded_hostnames_cust_creds_tooltip:
          'Prevent excluded domains from creating compromised customer credentials alerts (For example, 3rd-party systems)',
        excluded_hostnames_email_correspondence_tooltip:
          'Prevent excluded domains from creating Internal Email correspondence alerts',
        excluded_hostname_default_tooltip:
          'Prevent excluded domains from creating this type of alert. Use * to exclude all subdomains. For example, *.domain.com will exclude all subdomains under domain.com.',
        excluded_urls: 'Excluded URLs',
        excluded_urls_ph: 'domain.com/url/index.php | domain.com/*',
        excluded_urls_tooltip:
          'Prevent creation of candidates on URLs which are not interesting (For example, gift card balance check, non-username saved password URLs, etc)',
        excluded_emails: 'Excluded Emails',
        excluded_emails_ph: 'abc@company.com',
        excluded_emails_tooltip: 'Prevent excluded emails from creating Internal Email Correspondence alerts',
        excluded_matches: 'Excluded Matches',
        ignore_content_pattern: 'Ignore Content Pattern',
        ignore_content_pattern_tooltip: 'Intel items containing this pattern will be ignored.',
        ignore_content_pattern_ph: 'Only wildcard e.g. "Some Title*',
        excluded_matches_ph: 'Ambiguous word',
        excluded_matches_tooltip:
          'Prevent creation of candidates based on these matched strings (e.g. ambiguous keywords)',
        high_recipient_threshold: 'High Recipient Threshold',
        high_recipient_threshold_tooltip:
          'Emails with this many recipients will be consider likely to be spam and have lower confidence',
        ignore_high_recipient_alerts: 'Ignore High Recipient Alerts',
        ignore_high_recipient_alerts_tooltip: 'Whether to disable alert creation for emails with many recipients',
        ignore_subject_pattern: 'Ignore Subject Pattern',
        ignore_subject_pattern_ph: 'only wildcard e.g. "Some Title*"',
        ignore_subject_pattern_tooltip: 'Email subjects matching this pattern will be excluded from alerting',
        ignore_brand_derived_saas_interfaces: 'Ignore Brand-Derived SaaS Interfaces',
        ignore_brand_derived_saas_interfaces_tooltip:
          'Refers to interfaces which are likely related to the company via brand name, but are not explicitly employee interfaces. For example: acme.okta.com, acme.enterprise.slack.com, etc.)',
        ignore_no_corporate_resources: 'Ignore Malware Log With No Corporate Resources',
        ignore_no_corporate_resources_tooltip:
          'Ignores malware found on machines which only expose employee credentials to third party interfaces, and not for interfaces defined as employee-only',
        ignore_expired_payment_card: 'Ignore Expired Payment Cards',
        ignore_brand_matches: 'Ignore Brand Matches',
        ignore_brand_matches_tooltip: 'Whether to ignore candidates that rely only on brand detection',
        ignore_low_likelihood_filenames: 'Ignore Low Likelihood Filenames',
        ignore_low_likelihood_filenames_tooltip:
          'Ignore files with non sensitive content (e.g. logo, icon, wallpaper etc)',
        ignore_corrupt_passwords: 'Ignore Corrupt Passwords',
        ignore_autogenerated_malware_logs: 'Ignore Auto-Generated Malware Logs',
        allow_from_ulp: 'Generate alerts from ULP credentials',
        allow_from_ulp_tooltip:
          "Enabling this option will generate alerts for ULP (URL:Login:Password format files) credentials matching your monitored assets. Confidence levels follow the platform's standard classification framework. Be aware that ULP credentials sourced from Auto-Generated Malware Logs may receive elevated confidence scores, which can produce false positives at a rate that varies by environment.",
        generate_alerts_for_internal_generic_login_interface: 'Generate Alerts for Internal Web Interfaces',
        ignore_non_responsive_ports: 'Ignore Non-Responsive Ports',
        ignore_hashed_passwords: 'Ignore Hashed Password',
        ignore_hashed_passwords_tooltip:
          'Whether employee credentials alerts should be published if the detected password is hashed',
        minimum_length: 'Minimum Length',
        minimum_required_classes: 'Minimum Required Classes',
        minimum_required_classes_tooltip:
          'Minimum character classes required (for example - uppercase, lowercase, symbols, numbers)',
        minimum_entropy_bits: 'Minimum Entropy Bits',
        minimum_entropy_bits_tooltip: 'Minimum required password complexity (measured by entropy)',
        minimum_lowercase: 'Minimum Lowercase',
        minimum_uppercase: 'Minimum Uppercase',
        minimum_numbers: 'Minimum Numbers',
        minimum_symbols: 'Minimum Symbols',
        ignore_if_vulnerable_technology_discovered_more_than_x_days_tooltip:
          'Ignore if vulnerable technology was found more than X days ago',
        trigger_if_ssl_cert_expires_in_x_days: 'Ignore detections older than X days',
        minimum_non_letters: 'Minimum Non Letters',
        cyberint_score_threshold: 'Cyberint Score Threshold',
        score_threshold: 'Score Threshold',
        cyberint_score_threshold_tooltip:
          'The score represents the risk level of an unpatched vulnerability. The score is calculated by fusing multiple sources from different kind.',
        close_alerts_when_technology_is_not_detected: 'Close alerts when technology is not detected',
        close_alerts_when_exploit_is_not_detected: 'Close alerts when exploit is not detected',
        close_alerts_when_exploit_is_not_detected_tooltip:
          'The alert will be automatically closed if the exploit is not detected in 3 consecutive validation attempts (Approx. 24 to 32 hours)',
        enable_on_text_only_matches: 'Enable alerts on text-only matches (no logo match)',
        always_publish_phishing_beacon_alerts: 'Auto-publish Phishing Beacon matches',
        auto_close_on_successful_takedown: 'Auto-close on successful takedown',
        auto_close_on_successful_takedown_tooltip:
          'Closes the linked alert when the takedown reaches a successful terminal state.',
        auto_close_on_duplicate_takedown: 'Auto-close on duplicate hostname',
        auto_close_on_duplicate_takedown_tooltip:
          'Closes the alert affiliated with the duplicate TD at the moment the remediation analyst confirms the duplicate affiliation. No dependency on the primary URL being remediated.',
        auto_close_on_unreproducible_takedown: 'Auto-close on unreproducible takedown',
        auto_close_on_unreproducible_takedown_tooltip:
          'Closes the linked alert when the TD is cancelled due to inability to reproduce the site or geo-restriction.',
        auto_close_on_legitimate_site: 'Auto-close on legitimate site determination',
        auto_close_on_legitimate_site_tooltip:
          'Closes the linked alert when the TD review concludes the site is not malicious (False Positive status).',
        enable_tla_with_logo: 'Enable logo matches for short ambiguous keywords',
        generate_alert_for_technologies_without_version: 'Generate for Technologies w/o version ("Any")',
        ignore_open_port_if_service_name_does_not_match: 'Ignore open port if service name does not match',
        ignore_open_port_if_service_name_does_not_match_tooltip:
          'Ignore open port if the detected service name does not match the expected well-known service',
        handle_priority_assets_only: 'Handle priority assets only',
        handle_priority_assets_only_tooltip:
          "Priority assets are those covered by both ASM and TI modules. They serve as the 'Origin' for the discovery process and are considered high-priority. When this setting is set to 'Yes', alerts will be generated only for these priority assets.",
        alert_only_on_remote_exploitation: 'Exploitation Type',
        alert_only_on_remote_exploitation_tooltip:
          'Filter alerts based on exploitation type. Select "Remote Only" to receive alerts only for vulnerabilities that can be exploited remotely, or "All" to include all exploitation types.',
        publish_date_limitation_days: 'Publish Date Limitation (Days)',
        idp_validation: 'IDP Validation',
        idp_validation_off: 'Off',
        idp_validation_validation_only: 'Validation Only',
        idp_validation_auto_close: 'Auto Close'
      },
      aggregate_alerts: {
        unset: 'Unset',
        every_day: 'Every day',
        every_3_days: 'Every 3 days',
        every_week: 'Every week',
        every_2_weeks: 'Every 2 weeks',
        every_month: 'Every month',
        aggregate_alerts: 'Aggregate Alerts',
        tooltip:
          "We'll aggregate all such alerts, sent at the chosen frequency. To disable it choose 'Unset'.\nNote: Every change will reset the time of the aggregation."
      },
      'request-error-msg': {
        update_policy: 'Failed to update policy, please refresh the page and try again.',
        failedCatalog: 'Failed to load catalog, please refresh the page and try again.',
        failedCustomerConfig: 'Failed to load configuration, please refresh the page.',
        failedCustomerDefaultConfig: 'Failed to load default configuration.',
        failedCreateAlertConfig: 'Failed to update alert configuration, please refresh the page and try again.',
        failedUpdateAlertConfig: 'Failed to update alert configuration, please refresh the page and try again.'
      },
      'request-success-msg': {
        successCreateAlertConfig: 'Configuration has been updated successfully.',
        successUpdateAlertConfig: 'Configuration has been updated successfully.',
        update_policy: '%{policy} policy has been set successfully. The change will apply within 2 minutes.'
      },
      'select-options': {
        90: '3 months',
        180: '6 months',
        270: '9 months',
        365: '1 year',
        540: '1.5 years',
        730: '2 years',
        unset: 'Unset'
      },
      category: {
        fraud: 'Fraud',
        phishing: 'Phishing',
        attackware: 'Attackware',
        supply_chain: 'Supply Chain',
        brand: 'Brand',
        data: 'Data',
        vulnerabilities: 'Vulnerabilities',
        other: 'Other'
      },
      type: {
        refund_fraud: 'Refund Fraud',
        carding: 'Carding',
        coupon_fraud: 'Coupon Fraud',
        money_laundering: 'Money Laundering',
        victim_report: 'Victim Report',
        malicious_insider: 'Malicious Insider',
        extortion: 'Extortion',
        phishing_email: 'Phishing Email',
        phishing_kit: 'Phishing Kit',
        phishing_website: 'Phishing Website',
        lookalike_domain: 'Look-Alike Domain',
        phishing_target_list: 'Phishing Target List',
        malicious_file: 'Malware',
        reconnaissance: 'Reconnaissance',
        automated_attack_tools: 'Automated Attack Tools',
        business_logic_bypass: 'Business Logic Bypass',
        target_list: 'Target List',
        official_social_media_profile: 'Official Social Media Profile',
        impersonation: 'Impersonation',
        intellectual_property_infringement: 'Intellectual Property Infringement',
        unauthorized_trading: 'Unauthorized Trading',
        negative_sentiment: 'Brand Reputation',
        fake_job_posting: 'Fake Job Posting',
        defacement: 'Defacement',
        compromised_pii: 'Compromised PII',
        internal_information_disclosure: 'Internal Information Disclosure',
        compromised_payment_cards: 'Compromised Payment Cards',
        compromised_employee_credentials: 'Compromised Employee Credentials',
        compromised_customer_credentials: 'Compromised Customer Credentials',
        compromised_access_token: 'Compromised Access Token',
        ransomware: 'Ransomware',
        exposed_web_interfaces: 'Exposed Web Interfaces',
        hijackable_subdomains: 'Hijackable Subdomains',
        website_vulnerabilities: 'Website Vulnerabilities',
        vulnerabilities: 'Vulnerabilities',
        exposed_cloud_storage: 'Exposed Cloud Storage',
        exploitable_ports: 'Exploitable Ports',
        mail_servers_in_blacklist: 'Mail Servers in Blocklist',
        server_connected_to_botnet: 'Server connected to Botnet',
        email_security_issues: 'Email Security',
        certificate_authority_issues: 'Certificate Authority Issues',
        user_defined_saved_query: 'User Defined Saved Query',
        other: 'Other',
        ssl_tls: 'SSL/TLS',
        web_app_security: 'Web App Security'
      },
      subtype: {
        other: 'Other',
        user_defined_saved_query_hit: 'User Defined Saved Query',
        company_employee_private_access_token_exposed: 'Company Employee Private Access Token Exposed',
        malicious_insider_disclosing_company_internal_information:
          'Malicious Insider Disclosing Company Internal Information',
        ransomware_attack_targeting_company: 'Ransomware Attack Targeting Company',
        company_customer_credentials_offered_for_sale: 'Company Customer Credentials Offered for Sale',
        company_employee_credentials_offered_for_sale: 'Company Employee Credentials Offered for Sale',
        modified_application_potentially_bypassing_company_business_logic:
          'Modified Application Potentially Bypassing Company Business Logic',
        cashout_tutorial_targeting_company: 'Cashout Tutorial Targeting Company',
        lookalike_subdomain_potentially_targeting_company: 'Look-Alike Subdomain Potentially Targeting Company',
        fraudulent_activity_reported_by_company_customer: 'Fraudulent Activity Reported by Company Customer',
        malicious_insider_enabling_access_to_company_internal_information:
          'Malicious Insider Enabling Access to Company Internal Information',
        malicious_file_targeting_company_employees: 'Malicious File Targeting Company Employees',
        brute_force_tool_targeting_company: 'Brute Force Tool Targeting Company',
        company_confidential_file_offered_for_sale: 'Company Confidential File Offered for Sale',
        malicious_insider_engaged_in_fraudulent_activity: 'Malicious Insider Engaged in Fraudulent Activity',
        phishing_kit_targeting_company: 'Phishing Kit Targeting Company',
        brand_abusing_website_impersonating_company: 'Brand Abusing Website Impersonating Company',
        company_source_code_exposed: 'Company Source Code Exposed',
        company_coupons_offered_for_sale: 'Company Coupons Offered for Sale',
        missing_company_domain_caa_records_detected: 'Missing Company Domain CAA Records Detected',
        pii_for_multiple_company_customers_offered_for_sale: 'PII for Multiple Company Customers Offered for Sale',
        company_employee_corporate_credentials_exposed: 'Company Employee Corporate Credentials Exposed',
        misconfigured_company_domain_dmarc_records_detected: 'Misconfigured Company Domain DMARC Records Detected',
        social_media_account_impersonating_company: 'Social Media Account Impersonating Company',
        social_media_account_impersonating_company_executive: 'Social Media Account Impersonating Company Executive',
        breached_data_potentially_related_to_company: 'Breached Data Potentially Related to Company',
        company_website_defaced: 'Company Website Defaced',
        web_application_vulnerability_exploit_published: 'Web Application Vulnerability Exploit Published',
        carding_tutorial_targeting_company: 'Carding Tutorial Targeting Company',
        exploitable_port_on_company_server_detected: 'Exploitable Port on Company Server Detected',
        cashout_services_targeting_company: 'Cashout Services Targeting Company',
        company_customer_payment_cards_offered_for_sale: 'Company Customer Payment Cards Offered for Sale',
        misconfigured_company_domain_spf_records_detected: 'Misconfigured Company Domain SPF Records Detected',
        fraudulent_refund_services_targeting_company: 'Fraudulent Refund Services Targeting Company',
        fraudulent_refund_tutorial_targeting_company: 'Fraudulent Refund Tutorial Targeting Company',
        malicious_file_employee_machine_infected_by_malware: 'Employee Machine Infected by Malware',
        fake_job_posting_impersonating_company: 'Fake Job Listing Impersonating Company',
        company_executive_pii_offered_for_sale: 'Company Employee PII Offered for Sale',
        missing_company_domain_dmarc_records_detected: 'Missing Company Domain DMARC Records Detected',
        extortion_scheme_targeting_company_executive: 'Extortion Scheme Targeting Company Executive',
        company_asset_designated_on_target_list: 'Company Asset Designated on Target List',
        suspicious_social_media_account_targeting_company_customers:
          'Suspicious Social Media Account Targeting Company Customers',
        company_product_unauthorized_resale: 'Company Product Unauthorized Resale',
        company_internal_email_correspondence_exposed: 'Company Internal Email Correspondence Exposed',
        company_mail_server_blacklisted: 'Company Mail Server Blocklisted',
        company_intellectual_property_used_without_authorization:
          'Company Intellectual Property Used without Authorization',
        company_customer_credentials_exposed: 'Company Customer Credentials Exposed',
        company_executive_designated_on_target_list: 'Company Executive Designated on Target List',
        potential_reconnaissance_on_company_domain: 'Potential Reconnaissance on Company Domain',
        company_employee_payment_cards_exposed: 'Company Employee Payment Cards Exposed',
        tool_potentially_bypassing_company_business_logic: 'Tool Potentially Bypassing Company Business Logic',
        counterfeit_company_product_offered_for_sale: 'Counterfeit Company Product Offered for Sale',
        credential_stuffing_tool_targeting_company: 'Credential Stuffing Tool Targeting Company',
        invalid_ssl_certificate_on_company_web_interface: 'Invalid SSL Certificate on Company Web Interface',
        lookalike_domain_potentially_targeting_company: 'Look-Alike Domain Potentially Targeting Company',
        data_scraping_tool_for_company_application: 'Data Scraping Tool for Company Application',
        exposed_company_web_interface: 'Exposed Company Web Interface',
        browser_extension_potentially_bypassing_company_business_logic:
          'Browser Extension Potentially Bypassing Company Business Logic',
        company_subdomain_vulnerable_to_hijacking: 'Company Subdomain Vulnerable to Hijacking',
        vulnerability_scanner_targeting_company: 'Vulnerability Scanner Targeting Company',
        active_phishing_website_targeting_company: 'Active Phishing Website Targeting Company',
        email_phishing_campaign_targeting_company: 'Email Phishing Campaign Targeting Company',
        malicious_file_targeting_company_customers: 'Malicious File Targeting Company Customers',
        company_coupons_prematurely_exposed: 'Company Coupons Prematurely Exposed',
        company_server_identified_as_connected_to_botnet: 'Company Server Identified as Connected to Botnet',
        missing_company_domain_spf_records_detected: 'Missing Company Domain SPF Records Detected',
        pii_for_multiple_company_customers_exposed: 'PII for Multiple Company Customers Exposed',
        company_customer_credentials_and_pii_exposed: 'Company Customer Credentials and PII Exposed',
        carding_services_targeting_company: 'Carding Services Targeting Company',
        malicious_url_distributed_on_company_social_media_profile:
          'Malicious URL Distributed on Company Social Media Profile',
        company_generated_credit_cards_detected: 'Company Generated Credit Cards Detected',
        exposed_company_cloud_storage_bucket_detected: 'Exposed Company Cloud Storage Bucket Detected',
        misconfigured_company_domain_caa_records_detected: 'Misconfigured Company Domain CAA Records Detected',
        potentially_exploitable_web_application_vulnerability_detected:
          'Potentially Exploitable Web Application Vulnerability Detected',
        company_executive_pii_exposed: 'Company Employee PII Exposed',
        mobile_app_impersonating_company: 'Mobile App Impersonating Company',
        mobile_app_distributed_unofficially: 'Mobile App Distributed Unofficially',
        company_customer_payment_cards_exposed: 'Company Customer Payment Cards Exposed',
        company_customer_payment_cards_and_pii_exposed: 'Company Customer Payment Cards and PII Exposed',
        company_confidential_file_exposed: 'Company Confidential File Exposed',
        extortion_scheme_targeting_company: 'Extortion Scheme Targeting Company',
        potential_scanner_output_published: 'Potential Scanner Output Published',
        negative_sentiment_targeting_company: 'Negative Sentiment Targeting Company',
        fake_job_posting_impersonating_company_employee: 'Fake Job Listing Impersonating Company Employee',
        company_social_media_profile_defaced: 'Company Social Media Profile Defaced',
        company_employee_third_party_credentials_exposed: 'Company Employee Third-Party Credentials Exposed',
        company_domain_ssl_tls_issue_detected: 'Company Domain SSL/TLS Issues Detected',
        third_party_vendor_breached: 'Third Party Vendor Breached',
        ransomware_attack_targeting_third_party_vendor: 'Ransomware Attack Targeting Third Party Vendor',
        vulnerable_technology_detected_on_exposed_company_asset:
          'Vulnerable Technology Detected On Exposed Company Asset',
        exploitable_vulnerability_found_on_company_asset: 'Exploitable Vulnerability found on a Company Asset',
        ssl_tls_certificate_expiry: 'SSL/TLS Certificate Expiry Notice',
        highly_ranked_cve_found_on_a_technology: 'Highly Ranked CVE Found on a Known Technology',
        exploit_found_on_company_asset: 'An Exploit found on a Company Asset',
        tls_outdated_version_ssl_tls_supported: 'Outdated SSL/TLS Version Supported',
        tls_no_forward_secrecy: "Cipher Suites Don't Support Forward Secrecy",
        tls_latest_version_not_supported: 'TLS 1.3 Not Supported',
        tls_server_has_known_vulnerability: 'Known SSL/TLS Vulnerability Detected',
        tls_insecure_cipher_suites: 'Insecure SSL/TLS Cipher Suites Detected',
        tls_weak_cipher_suites: 'Weak SSL/TLS Cipher Suites Detected',
        tls_server_accepts_insecure_renegotiation: 'Insecure SSL/TLS Renegotiation Enabled',
        vulnerable_technology_detected_on_manually_added_technology: 'Vulnerable Manually Added Technology Detected',
        web_app_security_missing_hsts_header_detected: 'Missing HSTS Header Detected On Exposed Company Asset',
        web_app_security_misconfigured_hsts_header_detected:
          'Misconfigured HSTS Header Detected On Exposed Company Asset',
        web_app_security_missing_x_frame_options_header_detected:
          'Missing X-Frame-Options Header Detected on Exposed Company Asset',
        web_app_security_misconfigured_x_frame_options_header_detected:
          'Misconfigured X-Frame-Options Header Detected on Exposed Company Asset',
        web_app_security_missing_x_content_type_options_header_detected:
          'Missing X-Content-Type-Options Header Detected on Exposed Company Asset',
        web_app_security_misconfigured_x_content_type_options_header_detected:
          'Misconfigured X-Content-Type-Options Header Detected on Exposed Company Asset',
        web_app_security_missing_content_security_policy_header_detected:
          'Missing Content-Security-Policy Header Detected on Exposed Company Asset',
        web_app_security_missing_referrer_policy_header_detected:
          'Missing Referrer-Policy Header Detected on Exposed Company Asset',
        web_app_security_missing_x_permitted_cross_domain_policies_header_detected:
          'Missing X-Permitted-Cross-Domain-Policies Header Detected on Exposed Company Asset'
      }
    },
    'non-targeted-alerts': {
      title: 'Strategic Intelligence',
      tabs: {
        categories: 'Strategic Intelligence',
        notifications: 'Notifications'
      },
      categories: 'Strategic Intelligence Configuration',
      categories_subtitle: 'Configure your strategic intelligence alert rules',
      category_rule_incident_findings: 'findings',
      category_rule_incident_match: 'matched this rule in the last 30 days',
      category_rule_incident_possible_incident:
        'This is for context only and does not reflect published alerts or guarantee future volume. Alerts will be generated only after the rule is enabled.',
      configuration: 'Rule Configuration',
      tag_default: 'System-Defined',
      create_new_rule: '+ Create New Rule',
      manage_notifications: 'Manage Notifications',
      schedule_tooltip_label: 'When is my next report?',
      schedule_tooltip: {
        system_defined_monthly:
          'Your first report is published upon account activation. Subsequent reports are published on the 1st of every calendar month.',
        system_defined_quarterly:
          'Reports are published on the 1st day of the first month of each business quarter (Jan, Apr, Jul, Oct). Reports are not generated upon activation - unless activation occurred in the last month of a quarter.',
        user_defined_monthly:
          'Your first report will be published on the 1st of next calendar month, then monthly thereafter.',
        user_defined_quarterly:
          'Your first report will be published on the 1st day of the next business quarter (Jan, Apr, Jul, or Oct - whichever comes next), then quarterly thereafter.'
      },
      system_defined_rule: {
        cyber_attacks_in_country_and_sector: 'Cyber Attacks in Country AND Sector',
        cyber_attacks_in_country_and_sector_tooltip: 'Shows attacks matching both country AND sector',
        cyber_attacks_in_country: 'Cyber Attacks in Country',
        cyber_attacks_in_country_tooltip: 'Shows attacks filtered by selected country',
        cyber_attacks_in_sector: 'Cyber Attacks in Sector',
        cyber_attacks_in_sector_tooltip: 'Shows attacks filtered by selected sector',

        news_in_country_and_sector: 'News in country AND Sector',
        news_in_country_and_sector_tooltip: 'Shows news matching both country AND sector',
        global_news: 'Global News',
        global_news_tooltip: 'Shows news tagged as global',
        reports_in_country_and_sector: 'Reports in country AND Sector',
        reports_in_country_and_sector_tooltip: 'Shows reports matching either country OR Sector OR both',
        global_reports: 'Global Reports',
        global_reports_tooltip: 'Shows reports tagged as global'
      },
      no_categories: 'No categories available',
      select_rule_to_view: 'Select a rule to view configuration',
      empty: {
        'select-rule': 'Select a rule to view configuration'
      },
      configuration_section: {
        title: 'Tenant Settings',
        confirm_title: 'Are you sure you want to change tenant configuration?',
        edit_tenant_configuration: 'Change Tenant Settings',
        countries: 'Countries',
        sectors: 'Sectors',
        select_countries: 'Select countries',
        select_sectors: 'Select sectors',
        set: 'Set',
        none: 'None',
        confirm_save: 'Save Changes',
        from: 'From',
        to: 'To',
        modal: {
          title: 'Change Tenant Settings',
          change: 'Change'
        }
      },
      form: {
        create_rule_title: 'Create New %{category} Rule',
        delete_rule_button: 'Delete Rule',
        rule_name: 'Rule Name',
        sector: 'Sector',
        country: 'Country',
        region: 'Region',
        scope_type: 'Report Scope',
        global: 'Global',
        activity_type: 'Activity Type',
        threat_actor: 'Threat Actor/Group',
        confidence_level: 'Confidence Level',
        cadence: 'Cadence',
        cadence_monthly: 'Monthly',
        cadence_quarterly: 'Quarterly',
        create_rule_button: 'Create',
        cancel_rule_button: 'Cancel',
        validation: {
          name_required: 'Rule Name is required',
          country_or_sector_required: 'Select at least one: Sector or Country',
          cadence_required: 'Cadence is required',
          region_country_exclusive: 'Region and country cannot be selected together'
        }
      },
      modal: {
        delete_rule_title: 'Delete Rule',
        delete_rule_message: 'Are you sure you want to delete the rule "%{ruleName}"? This action cannot be undone.',
        delete_rule_confirm: 'Delete',
        delete_rule_cancel: 'Cancel'
      },
      error: {
        'rule-fetch': 'Failed to fetch non-targeted alert rules',
        'rule-created': 'Failed to create rule',
        'rule-removed': 'Failed to removed rule',
        'rule-updated': 'Failed to update rule',
        'config-fetch-failed': 'Failed to fetch tenant configuration',
        'config-update-failed': 'Failed to update tenant configuration'
      },
      success: {
        'rule-created': 'Rule was created successfully',
        'rule-removed': 'Rule was removed successfully',
        'rule-updated': 'Rule was updated successfully',
        'config-updated': 'Tenant configuration updated successfully'
      }
    },
    'brand-config': {
      addResourceModal: {
        title: 'Add Resource',
        sha256: 'SHA256',
        description: 'Description'
      },
      resourcesTable: {
        sha256: 'SHA256',
        description: 'Description',
        actions: 'Actions'
      },
      title: 'Brands Configuration',
      logos: 'Logos',
      favicons: 'Favicons',
      resources: 'Resources',
      takedown: 'Takedown',
      backToBrands: 'Back to Brands',
      assetName: 'Brand Name',
      hasLogo: 'Has Logo?',
      hasFavicons: 'Has Favicon?',
      hasResources: 'Has Resources?',
      configuredForPhishing: 'Is Monitored for Phishing?',
      relatedDomains: '# of Related Domains',
      removeLogoTitle: 'Remove Logo',
      removeLogoMessage: 'Are you sure you want to remove the logo ?',
      removeFaviconTitle: 'Remove Favicon',
      removeFaviconMessage: 'Are you sure you want to remove the favicon ?',
      uploadLogos: 'Upload Logos',
      failedToFetchBrands: 'Failed to fetch brands',
      failedToFetchFavicons: 'Failed to fetch favicons',
      logosUpdatedSuccessfully: 'Logos were updated successfully',
      faviconsUpdatedSuccessfully: 'Favicons were updated successfully',
      confirmRemoveResource: 'Are you sure you want to delete this resource?',
      failedToUploadLogos: 'Failed to upload logos',
      failedToUploadFavicons: 'Failed to upload favicons',
      failedToUpdateResources: 'Failed to update resources',
      failedToRefetchLogos: 'Failed to fetch logos',
      logosRemovedSuccessfully: 'The logo has been successfully removed',
      faviconRemovedSuccessfully: 'The favicon has been successfully removed',
      failedToRemoveLogo: 'Failed to remove logo',
      failedToRemoveFavicon: 'Failed to remove favicon',
      limitReached: 'Logo limit reached',
      selectDifferentFiles: 'Please select different logos',
      cant_upload_more_than_3_files: 'Maximum logo limit is 3.',
      fileSizeToBig: 'File size is too big',
      confirmationRequired: 'Confirmation Required',
      defaultWarningMessage: 'Are you sure you want to proceed with this action?'
    },
    'env-insights': {
      title: 'Environment Insights (Alpha)',
      'failed-to-fetch': 'Failed to fetch the required data. Please try to refresh the page.',
      'back-to-summary': 'Back to Environment Insights Summary',
      bulkOperationPanel: {
        buttons: {
          markAsIrrelevant: 'Mark as Irrelevant',
          markAsIrrelevantFailed: 'Failed to mark assets as Irrelevant',
          markAsIrrelevantSuccess: 'Assets marked as irrelevant successfully',
          cancelBtn: 'Cancel'
        },
        modal: {
          title: 'Mark as Irrelevant ?',
          message: 'Are you sure you want to mark the selected %{domainCount} domains as irrelevant?',
          note: '*Irrelevant domains will not be scanned for misconfigurations'
        }
      },
      alerts: {
        title: 'Alerts',
        alertCount: '%{value} alerts',
        totalCount: 'Total: %{total} alerts',
        column: {
          'alert-subtype': 'Alert Title',
          'total-closed': 'Total Closed',
          other_reasons: 'Other Closure Reasons',
          irrelevant: 'Irrelevant',
          false_positive: 'False Positive',
          no_longer_a_threat: 'No Longer a Threat',
          asset_belongs_to_my_organization: 'Asset Belongs to My Organization',
          irrelevant_alert_subtype: 'Irrelevant Alert Subtype',
          asm_no_longer_detected: 'No longer detected by ASM',
          asset_should_not_be_monitored: 'Asset Should not be Monitored',
          resolved: 'Resolved',
          asm_manually_closed: 'Manually closed by ASM',
          other: 'Other'
        }
      },
      asm: {
        title: 'ASM',
        assetsDiscoveryStatus: 'Assets Discovery last run ',
        assetDiscoveryNeverRan: 'Assets Discovery never ran on this environment',
        issueScanningStatus: 'Exposure scan last run ',
        assetsDiscoveryRun: 'Assets Discovery last run was %{lastRunDays} day(s) ago',
        issueScanningRun: 'Exposure scan last run was %{lastRunDays} day(s) ago',
        discoveryFailedInArow: 'Asset Discovery has failed 3 times in a row',
        discoverySucceededAtLeastOneTime: 'Asset Discovery succeeded at least once in the last 3 runs',
        scanFailedInArow: 'Exposure scan has failed 3 times in a row',
        scanSucceededAtLeastOneTime: 'Exposure scan succeeded at least once in the last 3 runs',
        na: 'N/A',
        demo_limit: 'Assets Discovery Limit:',
        notAvailable: 'ASM is not enabled on this environment',
        tbdInformation: 'What to do? How to solve? This information will be provided soon.',
        discoveriesFailInARow: 'Please Approach Support! at least 3 latest discoveries has been failed in a row.',
        scanFailInARow: 'Please Approach Support! at least 3 latest Exposure scans has been failed in a row.'
      },
      assets: {
        license_reached_limit: 'Asset license limit has been reached. Please make sure CSM contacts the customer.',
        license_exceeded: 'Asset license has been exceeded. Please make sure CSM contacts the customer.',
        license_ok: 'Assets license status is OK',
        title: 'Configured Assets / Licensed Assets'
      },
      header: {
        include_irrelevant: 'Include Irrelevant Assets',
        show_miss_configured_only: 'Show Misconfigured Only'
      },
      assetsTable: {
        countSelected: '%{countSelected} selected',
        column: {
          value: 'Asset',
          parent_id: 'Parent Asset',
          features: 'Features Enabled',
          is_parent_has_logo_and_favicon: 'Has Logo and Favicon',
          fix_the_problem: 'Fix the problem',
          all_good: 'All Good!',
          mark_as_validated: 'Actions',
          irrelevant: 'Irrelevant',
          monitor: 'Monitor',
          asset_validated_successfully: 'Asset %{name} dismissed from future phishing validations',
          asset_validated_failed: 'Failed to dismiss Asset %{name}'
        }
      },
      misconfiguration: {
        title: 'Misconfiguration',
        'phishing-configured-well': '%{type} are configured well',
        'phishing-configured-bad': '%{type} are not configured well',
        'phishing-no-link-to-parent': 'Domains without link to a parent Brand:',
        'phishing-img-url-issue': '%{type} without image url:',
        'phishing-total-problematic': 'Total problems found:',
        'phishing-feature-flag-issues': '%{type} with feature flag issues:',
        'favicon-please-add-tooltip': 'Please add favicon',
        'favicon-good': 'Favicon looks good',
        'favicon-missed': 'Missed favicon',
        'asset-diversity-good': 'Your asset type diversity seems good',
        'asset-diversity-low': 'Your asset type diversity seems low',
        'configured-assets-good': 'A sufficient number of assets are configured for this environment',
        'configured-assets-low': 'There are not enough assets in this environment, please consider adding some',
        'low-assets-diversity-tooltip':
          'This environment contains %{count} type of assets (%{types}). ' +
          'A low amount of asset types may indicate a lack of coverage for TI and may result in missed detections. It is possible to provide the customer with more impactful intelligence by adding more asset types. The following asset types are not configured on this tenant: %{notConfiguredAssetTypes}',
        'low-amount-configured-assets-tooltip':
          'This environment contains %{count} assets. ' +
          'A low amount of assets may indicate a lack of coverage for TI and may result in missed detections. It is possible to provide the customer with more impactful intelligence by adding more assets.',
        phishing_lookalike_title: 'Phishing / Lookalike domains',
        details: 'More details...',
        ti_assets_title: 'TI Assets',
        job_id: 'Job ID: ',
        notAvailable: 'Phishing is not enabled on this environment'
      },
      'asset-discovery-status': {
        success: 'finished successfully',
        failure: 'finished with errors',
        in_progress: 'in progress',
        abort: 'aborted',
        time_limit: 'not completed due to time limit'
      },
      createdDateFilter: {
        allTime: 'All Time',
        pastWeek: 'Past Week',
        pastTwoWeeks: 'Past Two Weeks',
        custom: 'Custom',
        apply: 'Apply',
        clear: 'Clear',
        from: 'From',
        to: 'To'
      }
    },
    'user-login-events': {
      title: 'User Login Events',
      failedRequest: 'Something went wrong...',
      failedFetchUser: 'Failed to fetch user',
      column: {
        timestamp: 'Timestamp',
        userName: 'Username',
        userIp: 'User IP',
        method: 'Method',
        status: 'Status',
        failureReason: 'Login Failure Reason'
      },
      method: {
        infinity: 'Infinity',
        login: 'Non-SSO',
        sso_login: 'SSO'
      },
      status: {
        success: 'Success',
        fail: 'Fail'
      },
      failureReason: {
        ip_not_whitelisted: 'IP not whitelisted',
        user_not_allowed_to_use_cyberint_login: 'User not allowed to use %{companyName} login',
        wrong_password: 'Wrong password',
        wrong_mfa_code: 'Wrong MFA code',
        user_not_allowed_to_use_cyberint_sso_login: 'User not allowed to use %{companyName} SSO login',
        unable_to_verify_id_token: 'Unable to verify id token',
        invalid_mfa_code: 'Invalid MFA code'
      },
      filters: {
        title: 'Filters',
        clearAll: 'Clear all',
        applyButton: 'Apply',
        from: 'From',
        to: 'To'
      },
      paginationOption: {
        twenty: 'Show 20',
        fifty: 'Show 50',
        oneHundred: 'Show 100'
      }
    }
  },
  'asset-management': {
    pending_assets: 'Pending Assets',
    configured_assets: 'Configured Assets'
  },
  'search-page': {
    search: 'SEARCH',
    'no-results-for': 'No results found for ',
    'empty-search': 'Start Searching for Content',
    suggestions: 'Suggestions',
    'make-sure-all-words-spelled-correctly': 'Make sure that all words are spelled correctly',
    'try-different-keywords': 'Try different keywords',
    'try-more-general-keywords': 'Try more general keywords',
    'results-found': 'results found for: "%{search}"'
  },
  'feed-sort': {
    s: 'S',
    type: 'Type'
  },
  'entity-page': {
    association: 'Association',
    'threat-actors': 'Threat Actors',
    'threat-actor-groups': 'Threat Actor Groups',
    tools: 'Tools',
    techniques: 'Techniques',
    campaigns: 'Campaigns',
    'related-indicators': 'Related Intel Items',
    updated: 'Last Update',
    'no-description': 'No Description',
    'network-and-urls': 'Network & URL',
    'known-associates': 'Known Associates',
    'network-and-url': 'network and url',
    alias: 'Alias Name',
    comment: 'Comment',
    description: 'Description',
    image_url: 'Image Url',
    link: 'Link',
    'add-new-link-to-%{a}': 'Add New Link To %{a}',
    'add-link': 'Add Link',
    'remove-link': 'Remove Link'
  },
  'entity-types': {
    'threat-actor': 'Threat Actor',
    'threat-actor-group': 'Threat Actor Group',
    tool: 'Tool',
    'threat actor': 'Threat Actor',
    technique: 'Technique',
    campaign: 'Campaign',
    industry: 'Industry',
    vendor: 'Vendor',
    technology: 'Technology',
    keyword: 'Keyword',
    'bin-number': 'BIN Number',
    domain: 'Domain',
    url: 'URL',
    'ip-address': 'IP Address',
    email: 'Email',
    'youtube-account': 'Youtube Account',
    'facebook-account': 'Facebook Account',
    'twitter-account': 'Twitter Account',
    'vk-account': 'VK Account',
    'linkedin-account': 'Linkedin Account',
    'instagram-account': 'Instagram Account',
    'mobile-application': 'Mobile Application',
    'sensitive-code-identifier': 'Sensitive Code Identifier',
    'employee-login-interface': 'Employee Login Interface',
    person: 'Person',
    company: 'Brand',
    product: 'Brand',
    brand: 'Brand',
    'document-identifier': 'Document Identifier'
  },
  tabs: {
    customer: 'Customer: %{name}',
    entity: 'Entity: %{name}',
    search: 'Search: %{query}',
    global_search: 'Threat Knowledge Base Search',
    indicator: 'Intel Item: %{title}',
    forensic: 'Forensic Canvas: %{name}',
    digitalFootPrint: 'Digital FootPrint: %{name}',
    threadView: '%{sourceName} Thread: %{sourceTitle}',
    assets: 'Assets',
    technologies: 'Technologies',
    certificates: 'Certificates',
    exposure_items: 'Exposure Items',
    newBadge: 'NEW',
    betaBadge: 'BETA',
    alphaBadge: 'ALPHA'
  },
  'navigate-to-url-modal': {
    'go-to-url': 'Go To URL',
    'go-to-url-warning': 'You are going to another website, which can be dangerous!'
  },
  'download-modal': {
    'download-file': 'Download File',
    'download-file-warning': 'Would you like to also download the attached file? This file might be dangerous.'
  },
  customerTable: {
    name: 'Name',
    createdBy: 'Created By',
    envType: 'Environment Type',
    status: 'Status',
    accountType: 'Account Type',
    createdOn: 'Created On',
    server: 'Server',
    wl: 'WL'
  },
  'user-management': {
    email: 'Email',
    status: 'Status',
    'user-type': 'User Type',
    'created-on': 'Created On',
    'full-name': 'Full Name',
    'add-user': 'Add User',
    'disable-user': 'Disable User',
    'delete-user': 'Delete User',
    'enable-user': 'Enable User',
    password_verification: 'Password verification',
    password_verification_text: 'Please enter your password for saving the changes:',
    please_note: 'Please Note:',
    remove_user_warning:
      "This action will revoke all of this user's associated tokens. This means any generated tokens will become invalid, and access to services and data will not be allowed.",
    enable_user_message: 'Are you sure you want to enable this user?',
    disable_user_token_warning:
      'This user has %{count} active API tokens. Disabling the user will automatically revoke all their API tokens.',
    'update-user': 'Update User',
    'new-password': 'New Password',
    'confirm-password': 'Confirm Password',
    'your-password': 'Your Password',
    analyst: 'Intelligence Producer',
    manager: 'Admin',
    viewer: 'Intelligence Consumer',
    th: 'Threat Hunter',
    'mfa-status': 'MFA Status',
    service_account: 'Service Account',
    na: 'N/A',
    'mfa-title': 'Set up multi-factor authentication',
    'regenerate-secret': 'Regenerate',
    perspective: 'Perspective',
    cyberint_producer: 'Cyberint Producer',
    operational_producer: 'Operational Producer',
    operational_consumer: 'Operational Consumer',
    executive: 'Executive',
    sso_policy: 'SSO Policy',
    enforced: 'Enforced',
    enabled: 'Enabled',
    off: 'Off',
    users: 'Users',
    new_user: '+ New User',
    new_customer: '+ New Tenant',
    customerSuccessfullyRestored: 'The tenant was successfully restored',
    customerRestoreFailed: 'An error occurred while trying to restore the customer. Please try again later',
    customerSuccessfullyDisabled: 'The tenant was successfully disabled',
    customerDisableFailed: 'An error occurred while trying to disable the customer. Please try again later',
    userSuccessfullyDeleted: 'The user was successfully deleted',
    disableCustomer: 'Disable Customer',
    actionOnCustomer: '%{action} Customer',
    disableModalMessage: 'The tenant %{customerName} and its assets will be %{action}. Are you sure?',
    passwordReset: 'Password Reset',
    confirm: 'Confirm',
    teamid: 'Team ID',
    copyResetPassword: 'Copy Reset Password Link',
    copyInviteLink: 'Copy Invite Link',
    edit: 'Edit',
    resendInvite: 'Resend Invitation',
    resendResetPassword: 'Resend Reset Password Email',
    resetPassword: 'Reset Password',
    deleteUser: 'Delete User',
    cancelShowHidden: 'Cancel Show Hidden',
    activateShowHidden: 'Activate Show Hidden',
    updatingUserPreferences: 'Error updating user preferences',
    maxLimitReached: 'Max user limit reached',
    createNewUser: 'Create a new user',
    customerid: 'Internal Tenant ID',
    dataResidency: 'Data Residency',
    customer_creation_failed: 'Failed to create tenant',
    failed_to_set_max_users: 'Failed to set max users',
    white_label_modal: {
      title: 'Are you sure you want to continue?',
      content:
        "This action will affect the tenant's UI and the visibility of certain features and pages.\nIn addition, the tenant's environment URL will be changed."
    },
    'unlink-relink-env': {
      envSuccessfullyReactivated: 'The environment successfully reactivated',
      failedDeactivate: 'Failed to deactivate the environment',
      failedReactivate: 'Failed to reactivate the environment',
      wannaReactivate:
        'The tenant "%{customerId}" already exists but is currently inactive. Would you like to reactivate it? Alternatively, you can cancel and provide a new tenant name.',
      wannaNavigate:
        'The tenant "%{customerId}" already exists and is active. Would you like to go to the account settings of this tenant, or cancel to choose a different tenant name?',
      envDeactivated: 'The environment has been deactivated',
      envFailedDeactivate: 'Failed to deactivate environment'
    },
    exportToXlsx: 'Export to XLSX',
    bulk_operations: {
      selected_users: '%{smart_count} selected user |||| %{smart_count} selected users',
      disable_users: 'Disable Users',
      enable_users: 'Enable Users',
      reset_password: 'Reset Password',
      resend_invitation: 'Resend Invitation',
      change_sso_policy: 'Change SSO Policy',
      disable_confirmation_title: 'Disable Selected Users',
      enable_confirmation_title: 'Enable Selected Users',
      reset_password_confirmation_title: 'Reset Password for Selected Users',
      resend_invitation_confirmation_title: 'Resend Invitation to Selected Users',
      sso_policy_confirmation_title: 'Change SSO Policy for Selected Users',
      disable_confirmation_message:
        "Are you sure you want to disable the user? This action will revoke all of this user's associated tokens. This means any generated tokens will become invalid, and access to services and data will not be allowed. |||| Are you sure you want to disable %{smart_count} users?\nThis action will revoke all of these users' associated tokens. This means any generated tokens will become invalid, and access to services and data will not be allowed.",
      enable_confirmation_message:
        'Are you sure you want to enable the user? |||| Are you sure you want to enable %{smart_count} users?',
      reset_password_confirmation_message:
        'Are you sure you want to reset password for the user? This will send a password reset email. |||| Are you sure you want to reset password for %{smart_count} users? This will send password reset emails.',
      resend_invitation_confirmation_message:
        'Are you sure you want to resend invitation to the user? |||| Are you sure you want to resend invitation to %{smart_count} users?',
      sso_policy_confirmation_message:
        'Are you sure you want to set the SSO policy to "%{policy}" for the selected user? |||| Are you sure you want to set the SSO policy to "%{policy}" for %{smart_count} selected users?',
      disable_success: 'Successfully disabled the user |||| Successfully disabled %{smart_count} users',
      enable_success: 'Successfully enabled the user |||| Successfully enabled %{smart_count} users',
      reset_password_success:
        'Successfully sent password reset to the user |||| Successfully sent password reset to %{smart_count} users',
      resend_invitation_success:
        'Successfully resent invitation to the user |||| Successfully resent invitation to %{smart_count} users',
      sso_policy_success:
        'Successfully changed SSO policy for the user |||| Successfully changed SSO policy for %{smart_count} users',
      disable_error: 'Failed to disable all selected users',
      enable_error: 'Failed to enable all selected users',
      reset_password_error: 'Failed to reset password for all selected users',
      resend_invitation_error: 'Failed to resend invitation to all selected users',
      sso_policy_error: 'Failed to change SSO policy for all selected users',
      disable_partial_success: 'Disabled %{successCount} of %{totalCount} users. Failed users: %{failedUsers}',
      enable_partial_success: 'Enabled %{successCount} of %{totalCount} users. Failed users: %{failedUsers}',
      reset_password_partial_success:
        'Reset password for %{successCount} of %{totalCount} users. Failed users: %{failedUsers}',
      resend_invitation_partial_success:
        'Resent invitation to %{successCount} of %{totalCount} users. Failed users: %{failedUsers}',
      sso_policy_partial_success:
        'Changed SSO policy for %{successCount} of %{totalCount} users. Failed users: %{failedUsers}',
      and_more: 'and %{smart_count} more',
      max_users_exceeded: 'Bulk operations currently support up to 10 users at a time. Please adjust your selection.'
    },
    filters: {
      title: 'Filters',
      created_on: 'Created On',
      status: {
        title: 'Status',
        active: 'Active',
        not_active: 'Not Active',
        invited: 'Invited'
      },
      user_type: {
        title: 'User Type',
        admin: 'Admin',
        intelligence_producer: 'Intelligence Producer',
        intelligence_consumer: 'Intelligence Consumer'
      },
      mfa_status: {
        title: 'MFA Status',
        off: 'Off',
        on: 'On'
      },
      sso_policy: {
        title: 'SSO Policy',
        off: 'Off',
        enabled: 'Enabled',
        enforced: 'Enforced'
      }
    },
    allow_self_reset_pw: {
      title: 'Enable User Self-Password Reset',
      info: 'This option allows the admin to grant users the ability to reset their own passwords.'
    },
    settings: {
      title: 'User Management Settings',
      description: 'Global defaults applied to all users in this account',
      authentication: {
        title: 'Authentication',
        description: 'Password and login configuration'
      },
      notifications: {
        title: 'Notifications',
        description: 'Account-wide notifications behaviour'
      }
    },
    tabs: {
      users: 'Users',
      settings: 'Settings',
      'token-management': 'Token Management'
    }
  },
  'knowledge-base': {
    'create-entity': 'Create %{entityName}'
  },
  'entity-subtypes': {
    '%{entityType}-type': '%{entityType} Type',
    'community-page': 'community page',
    'official-page': 'official page',
    'fake-page': 'fake page',
    'community-user': 'community user',
    'official-user': 'official user',
    'official-url': 'official',
    'suspicious-url': 'suspicious',
    'phishing-url': 'phishing',
    vip: 'VIP'
  },
  'create-indicator': {
    category: 'Category',
    'content-type': 'Content Type',
    'item-id': 'Item ID',
    'published-date': 'Published Date',
    expires: 'Expires',
    'sub-forum': 'Sub forum',
    syntax: 'Syntax',
    'author-id': 'Author ID',
    'indicator-inserted-successfully': 'Indicator inserted successfully'
  },
  'create-alert': {
    asset: 'Asset'
  },
  'indicator-title': {
    'ip-check': 'IP Check: %{ip}',
    'new-leaked-credentials-found-for-name': 'New leaked credentials found for %{name}',
    'no-leaked-credentials-found-for-name': 'No leaked credentials found for %{name}'
  },
  'indicator-preview': {
    'no-bad-reputation-found-for-ip': 'No bad reputation found for %{ip}',
    'ip-has-bad-reputation': 'IP %{ip} has bad reputation',
    'ip-has-bad-reputation-of-type': 'IP %{ip} has bad reputation of type %{types}',
    'no-data-found-for-ip': 'No data found for IP %{ip}',
    'ip-is-private-ip': '%{ip} is private IP',
    'number-new-credentials-found-for-name': '%{number} new credentials found for %{name}',
    'number-new-credentials-found-for-name-out-of-range': 'More than %{number} new credentials found for %{name}'
  },
  'main-menu': {
    'iocs-dashboard': 'IOCs Dashboard'
  },
  'customer-features': sharedFeatures.title,
  'customer-sub-environments': {
    title: 'Child Tenants',
    sub_title: 'Please ensure you are fully aware of the impact before making any changes',
    select_customer: 'Configure child tenants',
    updated_succesfully: 'Child tenants configured successfully',
    fail_to_update: 'Failed to update child tenants'
  },
  infinity_auth: {
    error_copied: 'Error details was copied!'
  },
  demo_page: {
    email: 'Work Email',
    firstName: 'First Name',
    lastName: 'Last Name',
    phone: 'Phone Number',
    country: 'Country',
    apply_fail: 'Invalid or missing values',
    get_demo: 'Get a Demo!',
    get_demo_button: 'Get a Demo',
    applied_before: 'Your demo request is already in progress',
    applied_success: 'Demo request applied successfully',
    cp_employee_msg: 'If you want to learn more about ERM - Go to our Wiki page',
    cp_click_here: 'Click here'
  },
  infinity_tenants: {
    title: 'Infinity Tenants',
    sub_title: 'Specify parent Infinity tenant Ids',
    tenant_selection: 'Tenant Selection',
    select_customer: 'Set Infinity tenants',
    no_tenants_selected: 'No tenants selected yet',
    validation_warnings: 'Validation Warnings',
    quantum_actions: 'Quantum Integration Actions',
    update_success: 'Infinity Tenants configured successfully',
    confirmation_title: 'Critical Warning: Tenant Mapping Risk',
    update_validation_attached:
      'Infinity Tenant (%{name}) is already attached to another Argos Tenant (%{other}) |||| Infinity Tenant (%{name}) is already attached to other Argos Tenants (%{other})',
    update_fail: 'Failed to update Infinity Tenants',
    rotate_keys: 'Rotate Keys',
    test_connection: 'Test Connection',
    rotate_keys_confirmation_title: 'Confirm Keys Rotation',
    rotate_keys_confirmation_message: 'Are you sure you want to rotate Quantum integration keys?',
    rotate_keys_confirmation_note: 'Note: Keys rotation can take up to 90 seconds',
    rotate_keys_success:
      'Keys rotated successfully. Note: Quantum encryption keys rotation can take up to 1.5 minutes.',
    rotate_keys_fail: 'Failed to rotate keys',
    test_connection_success: 'Connection successful',
    test_connection_fail: 'Connection failed. Enable the Quantum integration through the SmartConsole'
  },
  'customer-whitelist-ips': {
    warning: 'At present, system access is unavailable for users. Kindly specify the Allowed IPs.',
    warning_all_ips:
      'Since the environment lacks specific IPs for whitelisting, it is advisable to ensure that every configured user has Multi-Factor Authentication (MFA) enabled.',
    configure_now: 'Click here to configure whitelist',
    'whitelist-ips': 'Allowed IPs',
    'add-ip': 'Add IP',
    'whitelist-ips-updated-successfully': 'Whitelist IPs updated successfully',
    'single-ip-subnet-range-supported':
      'Single IP, subnet and range of IPs are supported (e.g. 1.2.3.4, 1.2.3.0/24, 1.2.3.4-1.2.3.7)',
    'single-ip-subnet-range': 'Enter IP, subnet, or IP range'
  },
  'customer-update': {
    'success-message': 'Tenant updated successfully',
    failed_to_update_customer: 'Failed to update customer. Please try again.',
    failed_to_update_configuration: 'Failed to update customer configuration. Please try again.',
    failed_to_white_label_customer: 'This tenant can only be white labeled by Cyberint customer support.'
  },
  'ip-check': {
    'general-details': 'General Details',
    'source-index': 'Source #%{index}',
    owner: 'Owner',
    city: 'City',
    'detected-urls': 'Detected URLs',
    'resolved-urls': 'Resolved URLs',
    'detection-date': 'Detection Date',
    positives: 'Positives',
    'last-resolve-date': 'Last Resolve Date',
    'reputation-type': 'Reputation Type',

    'created-date': 'Created date',
    'observation-date': 'Observation date',
    classification: 'Classification',
    tool: 'Tool',
    technique: 'Technique',
    country: 'Country',
    'related-domain': 'Related Domain',
    description: 'Description'
  },
  severity: {
    info: 'Info',
    low: 'Low',
    medium: 'Medium',
    high: 'High',
    'very-high': 'Very High'
  },
  language: {
    english: 'English',
    hebrew: 'Hebrew'
  },
  'send-email': {
    'send-by-email': 'Send by email',
    to: 'To',
    subject: 'Subject',
    content: 'Content',
    'send-email': 'Send Email',
    'interesting-indicator-from-source': 'Interesting Intel Item from %{source}',
    'interesting-alert-on-asset-type': 'Interesting Alert on %{assetType}',
    'link-to-indicator-will-be-added-to-email': 'Link to intel item will be added at the bottom of the email',
    'one-of-specified-emails-is-not-valid': 'One of specified emails is not valid'
  },
  comments: {
    'type-your-comment-here': 'Type your comment here...'
  },
  'action-types': {
    'action-type': 'Action Type',
    alert: 'Alert'
  },
  'data-leakage': {
    'publishing-source': 'Publishing source',
    'first-publish-date': 'First Publish Date',
    'last-publish-date': 'Last Publish Date',
    publisher: 'Publisher',
    'no-leaked-credentials-found': 'No leaked credentials found',
    'was-found-previously-in-num-other-sources': 'Was found previously in %{number} other sources'
  },
  'open-ports': {
    'port-number': 'Port Number',
    details: 'Details'
  },
  statistics: {
    'system-indicators': 'System Intel Items',
    'new-assets': 'New Assets',
    'total-assets': 'Total Assets',
    'total-alerts': 'Total Alerts',
    'h-and-vh-indicators': 'H&VH Intel Items'
  },
  'ioc-dashboard': {
    'total-weekly-threats': 'Total Weekly Threats',
    'threats-by-countries': 'Threats by Countries',
    'threats-by-countries-top': 'Threats by Countries (Top 5)',
    'threats-by-industries-top': 'Threats by Industries (Top 5)',
    'threats-by-type': 'Threats by Type',
    'bots-distribution': 'Bots Distribution'
  },
  'operational-dashboard': {
    'similar-alerts': '%{smart_count} similar alert |||| %{smart_count} similar alerts',
    'no-similar-alerts': 'no similar alerts',
    indicators: 'Intel Items',
    'threat-actors-indicators': 'Indicators per Threat Actor',
    'threat-actors-top-categories': 'Top %{categories} Categories per Threat Actor',
    'trending-categories': 'Trending Categories',
    'indicators-categories': 'Indicators Categories',
    'threat-actors': 'Active Threat Actors',
    'trending-assets': 'Trending Assets',
    assets: 'Assets',
    'trending-sources': 'Trending Sources',
    'active-sources': 'Active Sources',
    'no-trending-categories': 'No Classified Intel Items Were Recently Found',
    'no-threat-actors': 'No Active Threat Actors Were Recently Found',
    'no-sources': 'No Sources Were Recently Found',
    'no-assets': 'No Assets Were Recently Found',
    'assets-types': 'Assets Types',
    'sources-types': 'Sources Types',
    'total-alerts-per-type': 'Total Alerts per Type',
    'categories-distribution': 'Categories Distribution',
    'hover-to-see-distribution': 'Hover on any bar to see Categories distribution',
    'severity-split': 'Severity Split',
    'additional-information': 'Additional information you might be interested in'
  },
  'ioc-feed': {
    'new-iocs': 'New IOCs',
    'created-date': 'Created Date',
    'observation-date': 'Observation Date',
    asn: 'ASN',
    source: 'Source',
    classification: 'Classification',
    'tool-detected': 'Tool Detected',
    'related-domain': 'Related Domain',
    industry: 'Industry',
    confidence: 'Confidence',
    'ip-or-domain': 'IP or Domain',
    'please-apply-filters-to-export-to-csv': 'Please apply filters to enable exporting to CSV',
    'upload-csv': 'Upload CSV',
    'your-query-contains-total-results':
      'Your query contains %{total} results. Export will contain only 100,000 lines.',
    'file-format-not-supported': 'File format not supported, please contact Cyberint for more information',
    'successfully-uploaded-number-lines': 'Successfully uploaded %{number} lines',
    'first-observation': 'First Observation Date',
    'last-observation': 'Last Observation Date',
    'sources-amount': '# of Observing Sources',
    'observed-times': '# of Times Observed',
    'highest-confidence': 'Confidence (highest)',
    'latest-confidence': 'Confidence (latest)'
  },
  siem: {
    'new-siem-events': 'New SIEM Events',
    time: 'Time',
    title: 'Title',
    severity: 'Severity',
    'report-source': 'Report Source',
    'source-ip': 'Source IP',
    'destination-ip': 'Destination IP',
    'source-user': 'Source User',
    'destination-user': 'Destination User',
    'destination-port': 'Destination Port',
    url: 'URL',
    'filter-time': 'Time',
    'filter-severity': 'Severity',
    'filter-free-text': 'Free Text'
  },
  'siem-severity': {
    unknown: 'Unknown',
    low: 'Low',
    medium: 'Medium',
    high: 'High',
    'very-high': 'Very High'
  },
  phishing: {
    'asset-name': 'Asset Name',
    'source-code': 'Source Code',
    'url-matches': "The site’s URL contains expressions that resemble the company's assets: %{assets}"
  },
  telegram: {
    'thread-link': 'View in thread'
  },
  'navigation-bar': {
    remove: {
      title: 'Remove Intel Items?',
      'submit-text': 'Yes, remove',
      'confirmation-text':
        'Are you sure you want to remove the <strong>%{smart_count} intel item</strong> selected? |||| Are you sure you want to remove the <strong>%{smart_count} intel items</strong> selected?',
      disclaimer: 'You can always find them in the "Removed" folder.'
    },
    'move-to': {
      title: 'Move To Folder',
      'submit-text': 'Done',
      'select-placeholder': 'Select folder'
    }
  },
  'author-investigation': {
    'number-of-indicators': 'No. of Intel Items',
    'number-of-indicators-parentheses': '(Total)',
    'contact-details': 'Contact Details',
    'contact-details-parentheses': '(Last 3 month)',
    'author-profile': 'Author Profile',
    overview: 'Overview',
    'button-before-date': {
      'three-months': '3M',
      'one-year': '1Y',
      'two-year': '2Y'
    },
    'first-seen': 'First seen',
    'last-seen': 'Last seen',
    'email-addresses': 'Email addresses',
    'related-urls': 'Related URLs',
    'phone-numbers': 'Phone Numbers',
    'icq-accounts': 'ICQ Accounts',
    'skype-accounts': 'Skype Accounts',
    'no-contacts': 'No Contact Details Were Found',
    'coverage-explained': '% of intel items by this author that contain the %{entityType}',
    'indicator-by-month': 'Total Intel Items by Month',
    'black-list-author': 'The information is unavailable due to author’s name ambiguity',
    'top-sources': 'Top Sources',
    'top-sources-indicators': 'Intel Items',
    'top-categories': 'Top Categories',
    'top-categories-pie-title': 'Categories split',
    'top-categories-no-classified-indicators': 'No Classified Intel Items Were Found'
  },
  'thread-view': {
    'thread-link': 'View in thread'
  },
  'indicator-label-editor': {
    'menu-placeholder': 'Search label...',
    'menu-placeholder-no-results': 'Labels not found'
  },
  browser: {
    'browser-not-supported': 'Browser Not Supported',
    supportChromeOnly: "You are using a web browser that isn't supported by Argos Edge",
    tm: 'TM',
    betterExperience: 'For a better experience please switch to Google Chrome.'
  },
  'invite-user-form': {
    'focal-point': 'Focal Point',
    'zip-password': 'Zip Password',
    'analyst-email': 'Analyst Email',
    'invite-users': 'Invite Users',
    'upload-users': 'Upload Users CSV'
  },
  topbar: {
    logout: 'Sign Out',
    languageSwitcher: {
      ariaLabel: 'Language: %{lang}'
    },
    themeMode: {
      toDark: 'Switch to dark mode',
      toLight: 'Switch to light mode',
      light: 'Light',
      dark: 'Dark'
    },
    myaccount: 'account settings',
    'search-customer-place-holder': 'Search customer',
    'customer-support': 'Customer Support',
    contactMyAdmin: 'Contact My Admin',
    contactMySend: 'Send',
    contactMyAdminValidation: 'Message length should be between 1-255 characters',
    contactMyAdminSuccess: 'Message sent successfully',
    contactMyAdminFail: 'Failed to contact admin',
    'online-help': 'Online Help',
    e_learning: 'E-Learning Portal',
    search_navigation_menu: {
      threat_knowledgebase: 'Threat Knowledge Base Search',
      credentials_search: 'Credentials Search',
      placeholder: 'Search...',
      knowledgebase_tab: 'Knowledge Base',
      credentials_tab: 'Credentials Search',
      cve_tab: 'CVEs',
      malware_tab: 'Malware',
      threat_actors_tab: 'Threat Actors'
    }
  },
  'assets-configuration': {
    title: 'Assets License',
    apply: 'Apply',
    configured: 'utilized',
    fields: {
      assets_limit: 'Number of Assets Permitted',
      customers_scope: 'Customers License'
    },
    errors: {
      'fetch-customer-configuration': 'Failed to fetch the assets configuration data',
      'fetch-ti-assets-limit': 'Failed to fetch the TI Keywords limit',
      'fetch-asm-assets-limit': 'Failed to fetch ASM Assets limit',
      update: 'Failed to update the assets configuration limit',
      'input-not-a-number': 'The value should be a number',
      'permitted-value-less-than-scope':
        'The number of permitted assets cannot be smaller than the scope. It can either be equal or larger from the scope',
      'maximum-number-allowed': 'Maximum number allowed - '
    },
    success: {
      update: 'Assets and Keywords configuration limits were updated successfully'
    }
  },
  'supply-chain-configuration': {
    title: 'Supply Chain Configuration',
    apply: 'Apply',
    configured: 'utilized',
    fields: {
      vendor_limit: 'Number of Vendors Permitted'
    },
    errors: {
      'fetch-customer-configuration': 'Failed to fetch supply chain vendor limit configuration data',
      'fetch-vendor-inventory-scope': 'Failed to fetch the current vendor count being used',
      update: 'Failed to update the vendor limit configuration limit',
      'input-not-a-number': 'The value should be a number',
      'maximum-number-allowed': 'Maximum number allowed - '
    },
    success: {
      update: 'Vendor configuration limits were updated successfully'
    }
  },
  'takedown-configuration-form': {
    title: 'Takedown Configuration',
    'fetch-failed': 'Failed fetching configuration',
    'add-brand': 'Add Brand',
    'missing-url': 'Missing URL',
    'invalid-url': 'Invalid URL',
    'missing-brand-url': 'Missing Brand URL',
    'missing-brand-name': 'Missing Brand Name',
    'brand-placeholder': 'Brand Name',
    'related-brands': 'Related Brands',
    'original-url': 'Original URL',
    'original-url-placeholder': 'Official URL (e.g. https://microsoft.com)',
    'updated-successfully': 'Updated configuration successfully',
    'no-brands': 'No related brands were configured'
  },
  meantimes_form: {
    title: 'MTTA & MTTR Start Date',
    description: 'Select a date to reset MTTA & MTTR',
    tooltip:
      'Will set the start date for MTTA & MTTR statistics.\nThe start date will be determined by the following order of precedence:\n\n1. MTTA & MTTR start date\n2. Environment creation date',
    last_reset_date: 'Reset date: ',
    clear_button: 'Revert',
    meantime_update_success: 'MTTA & MTTR start date has been updated successfully',
    meantime_update_failure: 'Failed to update MTTA & MTTR start date. Please try again.',
    meantime_deletion_success: 'MTTA & MTTR start date has been deleted successfully',
    meantime_deletion_failure: 'Failed to delete MTTA & MTTR start date. Please try again.',
    fetch_config_failure: 'Failed to fetch MTTA & MTTR start date'
  },
  alert_policy: {
    title: 'Alert Policy',
    content: 'When enabled, alert policies will be supported. Policies can be applied in Alerts Configuration screen.',
    failed_to_update: 'Failed to update alert policy configuration. Please try again.',
    update_success: 'Alert policy configuration was updated successfully',
    failed_to_delete_policy: 'Failed to delete alert policy configuration.'
  },
  session_timeout: {
    title: 'Session Timeout',
    tooltip: 'This will set the session timeout for all users within this tenant.',
    warning: 'Long session periods may pose security risks.',
    success_message: "A new session timeout will take effect upon users' re-login",
    failure_message: 'Failed to update session timeout. Please try again.',
    timeout_values: {
      900: '15 minutes',
      1800: '30 minutes',
      3600: '1 hour (Default)',
      5400: '1.5 hours',
      10800: '3 hours',
      21600: '6 hours',
      43200: '12 hours'
    }
  },
  e_learning: {
    title: 'E-Learning',
    content: 'When enabled, users will be able to send registration emails for Litmos training.',
    failed_to_update: 'Failed to update E-Learning configuration. Please try again.',
    update_success: 'E-Learning configuration was updated successfully'
  },
  'session-expiration-modal': {
    'not-expired': {
      title: 'Session is About to Expire!',
      message: 'Your session will expire in %{seconds} seconds.'
    },
    expired: {
      title: 'Your Session Has Expired',
      message: "Please log in again. Don't worry, we've kept your last opened page and filters in place."
    },
    'keep-working': 'Keep working',
    logout: 'Logout',
    login: 'Login'
  },
  'filter-queries': {
    'select-placeholder': {
      close: 'Add Predefined Queries',
      open: 'Search query'
    },
    'delete-notification': {
      title: 'Delete Saved Query',
      content: {
        firstPart: 'Are you sure you wish to delete ',
        secondPart:
          ' query? The query will no longer be available to any of the users in the environment even if it is currently saved to their list.'
      },
      btns: {
        delete: 'Delete',
        cancel: 'Cancel'
      }
    }
  },
  'reset-password-modal': {
    areYouSureTitle: 'Are you sure you want to reset %{username} password?',
    emailWithLink: 'We will send an email for this user with a link to select a new password',
    validLink: 'The link is valid for the next 24h'
  },
  'ioc-indicator': {
    source: 'IOC Feed',
    title: 'Potential IOC found',
    last_observation: 'Last Observation Time: ',
    ri_enrichment: 'Enrichment from IOC Feed',
    iocType: {
      ipv4: 'IPv4 Address',
      domain: 'Domain',
      url: 'URL',
      'file/sha256': 'File Hash - SHA 256'
    }
  },
  customers: {
    clearFilters: 'Clear Filters',
    accountType: 'Account Type',
    parentCustomers: 'Parent Tenants',
    white_label_parent_tenants: 'White Label Parent Tenants',
    white_label_parent: 'White Label Parent',
    white_label: 'White Label',
    newCustomer: 'New Tenant',
    nameCannotBeEmpty: 'Environment Name cannot be empty',
    name_format: 'Please use only alphanumeric characters, separated by space, _ , or -',
    serverCannotBeEmpty: "Environment's domain cannot be empty",
    passwordCannotBeEmpty: 'Default admin password cannot be empty',
    environmentTypeCannotBeEmpty: 'Environment type cannot be empty',
    accountTypeCannotBeEmpty: 'Account type cannot be empty',
    timezoneCannotBeEmpty: 'Time Zone cannot be empty',
    partner_title: 'Partner Demo Environment',
    prospect_title: 'Prospect Environment',
    demo_title: 'Demo Environment',
    production_title: 'Customer Environment',
    poc_title: 'POC Environment',
    partner_info: 'Create an Argos Edge Demo environment for a partner for easy demonstration.',
    prospect_info: 'Create an Argos Edge Demo environment for easy demonstration.',
    demo_info: 'This is a simple ASM Demo environment only',
    production_info: 'Create a new Argos Edge tenant',
    poc_info: 'Create and configure a dedicated Proof of Concept Argos tenant.',
    partner_note:
      'The environment includes: \n\n' +
      '1. A ready-made tenant of Argos Edge™ with multiple examples included. \n\n' +
      '2. A reusable tenant for creating a dedicated, ad-hoc, Argos Edge demonstration for a prospect. ',
    prospect_note:
      'The environment includes: \n\n' +
      '1. A ready-made tenant of Argos Edge™ with multiple examples included. \n\n' +
      '2. A reusable tenant for creating a dedicated, ad-hoc, Argos Edge demonstration for a prospect. \n\n' +
      '3. An ASM Demo environment to preset Assets discovery, issues, and organization security score. ',
    demo_note: 'No other features will be available in this environment, usually used for conferences mode',
    production_note: '',
    poc_note: 'Note: This Tenant should be disabled at the end of the POC.',
    choose_an_environment: 'Which environment would you like to create?',
    customer_details: 'Customer Details',
    name: 'Environment Name',
    name_tooltip:
      "The environment name is the tenant's name, usually the customer's main brand name.\n\nNote:\n* The environment name is irreversible.\n* The name is used by default as part of the tenant's access URL (Environment URL).",
    server: 'Environment URL',
    server_tooltip: 'The environment URL is the URL used to access the specific tenant.',
    account_type: 'Account Type',
    environmentType: 'Environment Type',
    none: 'None',
    timezone: 'Timezone',
    password: "Default Admin's Password",
    mustContain: 'At least 8 chars: upper, lower, special, and number.',
    companySubdomain: 'Field must be a %{companyName} subdomain',
    asm_assets_limit: 'ASM Assets Limit',
    recommendedAssetsLimit:
      'The recommended ASM Assets Limit is 10k (to find quick results and not affect other scans and discoveries of production environments)',
    environment: 'environment',
    choose_an_env: 'Choose an environment type',
    environment_created_successfully: 'Environment created successfully',
    failed_creating_prospect_env: 'Failed to create prospect child environment',
    failed_to_assign_argos_demo: 'Failed to assign Argos Demo',
    environment_selection: 'Environment Selection',
    env_details: 'Environment Details',
    asm_demo_limit: 'ASM Demo Limit',
    summary: 'Summary',
    features_selection: 'Features Selection',
    automatic_alerts: 'Automatic Alerts',
    disabled: 'Disabled',
    enabled: 'Enabled',
    tenants: 'Environment Tenants',
    sector: 'Sector',
    geography: 'Geography',
    global_policy: 'Global Policy',
    tenant_connectivity: {
      title: 'Tenant Connectivity',
      whitelist: {
        title: 'Allowed IPs',
        label: 'Allow all IPs',
        all_ips_note:
          'Choosing the "Allow all IPs" option enables access to the environment from any device (IP). In this scenario, it is recommended to verify that either Single Sign-On (SSO) or Multi-Factor Authentication (MFA) is enabled for every configured user, ensuring an additional layer of security.',
        input_tooltip: 'Single IP, CIDR and range of IPs are supported (e.g. 1.2.3.4, 1.2.3.0/24, 1.2.3.4-1.2.3.7)',
        input: {
          error: { duplicate: 'IP already in list.', not_valid: 'IP is not valid.' }
        }
      },
      allow_reset_password: {
        title: 'Self Reset Password',
        allow_reset_password: 'Enable User Self-Password Reset',
        explanation: ''
      }
    },
    tenant_created_successfully: 'Tenant created successfully',
    tenant_converted_successfully: 'Tenant converted successfully',
    tenant_convert_unsupported: 'The selected tenant cannot be converted',
    failed_to_create_tenant: 'Failed to create tenant',
    failed_to_convert_tenant: 'Failed to convert tenant',
    not_found_parent_tenant: 'The defined parent tenant is invalid or not found',
    new_tenant: 'Create New Tenant',
    convert_tenant: 'Convert %{customerId} to Production Tenant',
    parent: 'Parent',
    tenant_type: 'Tenant Type',
    customer_id: 'Customer ID',
    create_tenant_screens: {
      tenant_type_selection: 'Tenant Type Selection',
      button_tenant_type_select: 'Select',
      tenant_details: 'Tenant Details',
      tenant_entitlements: 'Tenant Entitlements',
      tenant_features: 'Features',
      default: 'Default',
      tem_only: 'TEM Only',
      automatic_alerts: 'Automatic Alerts',
      initial_assets_config: 'Initial Assets Configuration',
      tenant_connectivity: 'Tenant Connectivity',
      asset_recommendations: 'Asset Recommendations',
      summary: 'Summary',
      exit_modal_title: 'Discard Changes?',
      exit_modal_content:
        "You're about to leave the wizard.\nAny changes you've made will be discarded.\nAre you sure you want to leave?",
      generatePwd: 'Generate password',
      copyClipboard: 'Copy to clipboard',
      passwordGeneratedNote:
        'Please note, your username will be %{username} and will be created automatically. We have generated a new password for you. You can reveal it or set a new one.',
      passwordNote: 'Please note, your username will be %{username} and will be created automatically.'
    },
    tenant_wizard_relink_modal: {
      title: 'Tenant already exists'
    },
    var_tenant: {
      poc_quota_reached:
        'The POC tenant limit for this Partner Management tenant has been reached. Contact Cyberint to raise the limit.'
    },
    tenant_types: {
      mssp_management: {
        title: 'MSSP Management',
        description: 'An Argos MSSP Management tenant providing consolidated management of the MSSP subtenants'
      },
      mssp_standalone_allocated: {
        title: 'MSSP Production Tenant (Standalone Credits)',
        description:
          'An Argos MSSP production tenant. \nThe allocated credits are assigned to the tenant by Cyberint administrator per the defined terms and cannot be modified by the MSSP.'
      },
      mssp_parent_allocated: {
        title: 'MSSP Production Tenant (Inherited Credits)',
        description: 'An Argos MSSP production tenant. \nThe allocated credits are assigned and managed by the MSSP.'
      },
      mssp_provisioning: {
        title: 'MSSP Provisioning',
        description: 'An Argos MSSP tenant for Demo and POC purposes.'
      },
      mssp_report: {
        title: 'MSSP Report',
        description:
          'An Argos MSSP tenant for report data collection and report generation. \nThis tenant will not provide ongoing collection and alert.'
      },
      cyberint_customer: {
        title: 'Cyberint Production',
        description: "An Argos production tenant for Cyberint's direct customer."
      },
      cyberint_provisioning: {
        title: 'Cyberint Provisioning',
        description: 'An Argos tenant for Cyberint Demo and POC purposes.'
      },
      cyberint_management: {
        title: 'Cyberint Management',
        description:
          'An Argos Cyberint Management tenant providing consolidated management of subtenants created for Demo and POCs for direct prospects.'
      },
      partners_var_management: {
        title: 'Partner Management',
        description:
          'An Argos Partner Management tenant providing consolidated management of POC subtenants created by the partner for their prospects.'
      },
      partners_var_provisioning: {
        title: 'Partner Provisioning',
        description: 'An Argos Partner tenant for POC purposes, managed under a Partner Management tenant.'
      },
      multi_tenant_management: {
        title: 'Multi Tenant Management',
        description: 'An Argos Multi Tenant Management tenant providing consolidated management of MT sub-tenants.'
      },
      tem_essentials_provisioning: {
        title: 'TEM POC',
        description: 'A TEM Essentials only Argos instance for demo and POC purposes'
      },
      tem_essentials_production: {
        title: 'TEM Production',
        description: 'A TEM Essentials only Argos instance'
      }
    },
    tenant_type_fields: {
      link_infinity_tenant: {
        title: 'Link Infinity Tenant',
        placeholder: 'Search by Infinity tenant name or ID',
        required: 'An Infinity tenant must be linked',
        no_results: 'No matching Infinity tenant found',
        loading: 'Searching Infinity tenants…',
        already_mapped: 'Already linked to another tenant',
        no_region: 'No data residency region configured'
      },
      self_service: {
        title: 'Optimized Alert Filtering',
        tooltip:
          'When enabled, alerts are strictly filtered to minimize noise and false positives. When disabled, more alerts are sent to "In Review" status for further triage.',
        auto_toggled_tooltip_enabled:
          'Optimized filtering has been automatically enabled based on your engagement type. Alerts will be strictly filtered to provide high-quality, actionable results.',
        auto_toggled_tooltip_disabled:
          'Optimized filtering has been automatically disabled based on your engagement type. More alerts will be sent to "In Review" status for further triage.'
      },
      engagement_type: {
        title: 'Engagement Type',
        placeholder: 'Engagement Type',
        required: 'Engagement Type cannot be empty'
      },
      tenant_name: {
        title: 'Tenant Name',
        placeholder: 'Tenant Name',
        tooltip:
          "The tenant's name is usually the customer's main brand name.\n\nNote:\n* Tenant name is irreversible.\n* The name is used by default as part of the tenant's access URL.",
        cannot_be_empty: 'Tenant Name cannot be empty',
        field_format: 'Please use only alphanumeric characters, separated by space, _ , or -',
        already_exists: 'This name is already taken.'
      },
      tenant_url: {
        title: 'Tenant URL',
        placeholder: 'e.g xyz.cyberint.io',
        tooltip: 'The URL used to access this specific tenant.',
        must_be_company_subdomain: 'Tenant URL must be a %{companyName} subdomain',
        cannot_be_empty: 'Tenant URL cannot be empty'
      },
      password: {
        title: 'Password',
        placeholder: "Default admin's password",
        cannot_be_empty: 'Password cannot be empty',
        field_format: 'At least 8 chars: upper, lower, special, and number.'
      },
      timezone: {
        title: 'Timezone',
        placeholder: 'Timezone',
        cannot_be_empty: 'Timezone cannot be empty'
      },
      region: {
        title: 'Data Residency',
        us: 'US Region',
        eu: 'EU Region',
        au: 'AU Region',
        US: 'US Region',
        EU: 'EU Region',
        AU: 'AU Region'
      },
      country: {
        title: 'Country',
        placeholder: 'Geography',
        cannot_be_empty: 'Country cannot be empty'
      },
      sector: {
        title: 'Sector',
        placeholder: 'Sector',
        cannot_be_empty: 'Sector cannot be empty'
      },
      session_timeout: {
        title: 'Session Timeout',
        placeholder: 'Session Timeout',
        tooltip: 'This will set the session timeout for all users within this tenant.'
      },
      parent_tenants: {
        title: 'Parent Tenants',
        placeholder: 'Parent Tenants'
      },
      users: {
        title: 'Users'
      },
      white_label: {
        title: 'White Label'
      },
      ip_range: {
        title: 'IP Range',
        tooltip: 'Choose Class C to reduce the IP range and accelerate the discovery.',
        CLASS_B: 'Class B',
        CLASS_C: 'Class C',
        default_suffix: '(Default)'
      },
      asm_asset_limit: {
        title: 'ASM Asset Limit',
        1000: '1,000',
        5000: '5,000',
        10000: '10,000',
        20000: '20,000',
        100000: '100,000 (Default)'
      },
      mfa_secret: {
        title: 'Multi-Factor Authentication',
        firstStep: 'Download Google Authenticator application to your mobile device',
        secondStep: 'Scan the QR code using the application',
        thirdStep: 'Fill in the verification code in the field below (you can use copy button)',
        fourthStep: 'Click the Login button',
        info: 'Download Google Authenticator application to your mobile device \n Scan the QR code using the application fill in the verification code in the field below and click the Login button'
      }
    },
    entitlements: {
      sub_tenants: 'Sub-Tenants',
      users: 'Users',
      th_users: 'Threat Hunting Users',
      threat_hunting_users: 'Threat Hunting Users',
      asm_assets: 'ASM Assets',
      ti_assets: 'TI Assets',
      coins: 'Coins',
      credits: 'Credits',
      reports: 'Reports',
      sc_vendors: 'Supply Chain Vendors',
      ri_custom_alert_rules: 'Raw Intelligence Custom Alert Rules',
      dl_custom_alert_rules: 'Data Lake Custom Alert Rules',
      phishing_beacons: 'Phishing Beacons',
      th_rules_row_data: 'Threat Hunting Rules (raw data)',
      th_rules_data_lake: 'Threat Hunting Rules (data lake)',
      integrations: 'Integrations',
      collection: 'Collection',
      contract: 'Contract',
      subscription: 'Subscription',
      capability: 'Capability',
      operation: 'Operation',
      purchased_amount: 'Purchased Amount',
      remaining_amount: 'Remaining Amount',
      allow_exceed: 'Allow Exceed',
      allocate: 'Allocate',
      allocation: 'Allocation',
      start_date: 'Start Date',
      end_date: 'End Date',
      ioc_intelligence_feed: 'IOC Intelligence Feed',
      ioc_enrichment_api: 'IOC Intelligence Enrichment API',
      feed_options: {
        none: 'None',
        tier1: 'Tier 1',
        tier2: 'Tier 2',
        tier3: 'Tier 3'
      },
      enrichment_options: {
        none: 'None',
        tier1: 'Tier 1 (up to 50K monthly API calls)',
        tier2: 'Tier 2 (up to 150K monthly API calls)',
        tier3: 'Tier 3 (up to 450K monthly API calls)',
        tier4: 'Tier 4 (unlimited)'
      },
      enrichment_config_failed:
        'Tenant was created, but failed to set the IOC Intelligence Enrichment API tier. You can set it from the License Management page.',
      cve_api: 'CVE API',
      invalid_format: 'Invalid date format',
      start_date_required: 'Value is required',
      end_date_required: 'Value is required',
      cross_not_in_range: 'Date not within subscription dates',
      not_in_contract_range: 'Date not within contract dates',
      min_credit_required: 'Minimum %{min} credits are required',
      failed_to_fetch_coins: 'Failed to fetch coins configuration',
      failed_to_fetch_credits: 'Failed to fetch credits configuration',
      failed_to_fetch_caps: 'Failed to fetch tenant limits.',
      failed_to_fetch_pool_usage: 'Failed to fetch tenant pool usage',
      pool_unavailable: 'N/A',
      exceeds_pool: 'Exceeds available pool — %{remaining} remaining'
    },
    tenant_creation_summary_modal: {
      initial_tenant_config: 'Initial Tenant Configuration',
      initial_assets_config: 'Initial Asset Configuration',
      asset_upload: 'Uploaded Assets',
      credit_allocation: 'Credit Allocation',
      error_summary: 'Errors Summary',
      credit_transaction_failure_message:
        "Tenant could not be activated due to a credit transaction failure. The tenant has been created but is disabled. Please check the parent account's credit balance.",
      aborted_by_user: 'Assets Upload has been Aborted by a user',
      asset_upload_error_counts: 'Asset Upload: %{failed} failed, %{rejected} rejected out of %{total} total',
      country_sector: 'Country and Sector',
      session_timeout: 'Session Timeout',
      asm_asset_limit: 'ASM Discovery Assets Limit',
      coins: 'Coins Purchased',
      credits: 'Credits Purchased',
      report_tenant_limit: 'Report Tenant Limit',
      supply_chain_vendor_limit: 'Supply Chain Vendor Limit',
      contract: 'Contract dates',
      asm_validation_scoping_settings: 'ASM Validation Scoping Settings',
      self_password_reset: 'Self Password Reset',
      user_session: 'User Idle Timeout Configuration',
      white_label_owner: 'White Label Settings',
      'customer.details': 'Customer Details (Country, Sector)',
      user_count_limit: 'User Limit',
      asset_limit: 'Assets Limit',
      continue_button: 'Continue to Tenant',
      title: 'Tenant Creation Progress and Summary',
      UPDATE_COMPANY: 'Update Company Asset',
      UPLOAD_LOGO: 'Update Log for the company Asset',
      UPLOAD_FAVICON: 'Update Favicon for the company Asset'
    },
    tenant_wizard_summary: {
      tenant_type: 'Tenant Type',
      tenant_name: 'Tenant Name',
      tenant_url: 'Tenant URL',
      company_name: 'Company Name',
      nicknames: 'Nicknames',
      timezone: 'Timezone',
      parent_tenants: 'Parent Tenant',
      white_label_parent: 'White Label Parent',
      allowed_ips: 'Allowed IPs',
      self_password_reset: 'Enable User Self Password Reset',
      features: 'Features',
      automatic_alerts: 'Automatic Alerts',
      self_service: 'Self Service',
      data_residency: 'Data Residency'
    },
    create_company: {
      main_domain: 'Main Domain',
      company_name: 'Company Name',
      description: 'Description',
      nicknames: 'Nicknames',
      group: 'Group',
      title: 'Initial Assets Configuration',
      company_name_tooltip: 'Company name value used for threat intelligence collection',
      nicknames_description:
        'Nicknames and aliases that contribute to the intelligence coverage of the Brand. For example Rolling.Stone, Stone-Rolling, RS Intenaitonal, etc. Up to %{limit} Nicknames can be added per asset.',
      nicknames_limit_reached: 'You have reached the maximum number of permitted Nicknames per asset.',
      tooCommonTitle: 'Company Name Configuration Issue',
      suggested_resources: {
        title: 'Please fill in the main domain to get logo and favicon suggestions',
        success: "We've retrieved a logo and favicon based on the above data. Please review and select if applicable",
        disclaimer: '*Note: In some cases, one or both may not be available.',
        logo: 'Logo',
        favicon: 'Favicon',
        no_images_found: 'No images were found'
      },
      errors: {
        name_empty: 'Company name cannot be empty',
        failed_to_create_company: 'Company asset can only be updated if Threat Intelligence feature is turned on',
        failed_to_update_logo: 'Failed to update logo',
        failed_to_update_favicon: 'Failed to update favicon',
        invalid_name: 'Group name is invalid'
      }
    },
    assets_recommendations: {
      title: 'Assets Recommendations',
      targeted_features_toggle: 'Configure targeted features per asset',
      description:
        "Here are the assets we've automatically identified for your tenant. Please review and select the ones relevant to your environment.",
      disclaimer:
        'Keep in mind, the company (%{company}) and domain (%{domain}) assets will be set up based on the information provided in the Initial Assets Configuration screen.',
      asset_type: 'Asset Type',
      asset_value: 'Asset Value',
      reason: 'Reason',
      person: 'Person',
      'sensitive code identifier': 'Sensitive Code Identifier',
      'employee login interface': 'Employee Login Interface',
      'mobile application': 'Mobile Application',
      domain: 'Domain',
      company: 'Company',
      no_assets_found: 'No assets were found',
      searching_assets: 'Discovering environment assets',
      failed_to_submit_assets: 'Failed to submit selected assets'
    },
    configuration_error: {
      asm_validation: 'Failed to configure ASM validation',
      white_label: 'Failed to configure white label owner',
      session_timeout: 'Failed to configure session timeout',
      customer_details: 'Failed to configure country and sector',
      password_reset: 'Failed to configure password reset',
      max_user_limit: 'Failed to configure max user limit',
      failed_to_configure_tenant: 'Tenant configuration failed'
    },
    features: sharedFeatures,
    autoAlerts: sharedFeatures.autoAlerts,
    summaryPage: {
      generalSettings: 'General Information',
      features: 'Selected Features per Environment',
      automaticAlerts: 'Automatic Alerts Information'
    },
    filters: {
      status: {
        active: 'Active',
        not_active: 'Not Active',
        title: 'Status'
      },
      environment_type: 'Environment Type',
      account_type: 'Account Type',
      created_on: 'Created On'
    }
  },
  'asm-configuration': {
    headerTitle: 'Automatic Asset Discovery, Validation, and Scoping Settings',
    headerSubTitle: 'Note: This process has an impact on the status of assets.',
    tabs: {
      assetValidationAndScoping: 'Asset Validation and Scoping',
      activeExposureValidation: 'Active Exposure Validation',
      integrations: 'Integrations'
    },
    integrations: {
      headerTitle: 'Integrations Management',
      subTitle: 'Configure integrations for ASM',
      activateIntegration: 'Activate Integration',
      activateDescription:
        'Choosing the "Activate integration" option enables data syncing from Cloudflare and allows ASM Discovery to start running automatically. You can also choose to activate discovery manually from here.',
      apiToken: 'API TOKEN',
      apiTokenTooltip:
        'Enter your Cloudflare API token to enable the integration. Ensure that your token has at least DNS (Read) and Zone (Read) permissions.',
      apiTokenPlaceholder: 'Copy the API token here',
      step1: 'Log in to your Cloudflare dashboard',
      step1Prefix: 'Log in to your',
      step1Suffix: 'dashboard',
      step2: 'Create an API token',
      step3: 'Copy the API token',
      step4: 'Paste the API token here to complete the integration',
      connect: 'Test & Save',
      delete: 'Delete',
      cancel: 'Cancel',
      successMessage: 'Integration secret saved successfully',
      errorMessage: 'Failed to save integration secret',
      deleteSuccessMessage: 'Integration secret deleted successfully',
      deleteErrorMessage: 'Failed to delete integration secret',
      cloudflare: 'Cloudflare'
    },
    autoValidationAndSettingsTooltip:
      'Automatic validation verifies the accuracy of the discovered unvalidated assets in ASM, and changes their status.',
    actions: {
      automaticValidationAndScoping: 'Automatic Validation and Scoping',
      automaticValidationAndScopingTooltip:
        "All assets with a high validation precision level will automatically be validated, and marked as 'Monitored'. When the validation and scoping is off - all newly discovered assets will remain unvalidated.",
      validationAndBulkScopingApplication: 'Automatic validation and bulk scoping will apply to',
      bulkScopingToAssetsWithPrecision: 'Bulk Scoping will apply to assets with precision level',
      bulkScopingToAssetsWithPrecisionTooltip:
        'Assets will be valid only if their discovery precision level is equal or greater than the threshold.',
      parkDomainScoping: 'Auto Scoping Setting for Parked Domains',
      parkDomainScopingTooltip:
        "As part of the auto-scoping, 'Unvalidated' parked domains that are validated will be set as 'Not Monitored' unless set differently." +
        "Parked domains already set to 'Monitored' will not be affected by this setting. Additionally, if a parked domain's parent asset is 'Unvalidated', the parked domain will inherit its status and will not override it",
      validAssetsStatusToBeSetAs: 'Valid assets status to be set as',
      validationWillApplyToAssetsOfTypes: 'Validation will apply to assets of types',
      validationWillApplyToDiscoveryReason: 'Validation and scoping will apply to selected discovery reasons'
    },
    limits: {
      systemLimits: 'System Limits',
      successfullyUpdatedASM: 'Limits updated successfully',
      FailedToUpdateASM: 'Failed to update Limits',
      asmAssetLimit: 'ASM Asset Limit',
      ipRange: 'IP Range',
      ipRangeConfirm: {
        title: 'Change IP Range to Class B',
        confirm: 'Yes, change to Class B',
        message:
          'This will expand netblocks from /24 (256 IPs) to /16 (65K IPs), significantly increasing scan load. Please consider this carefully for provisioning tenants, ISPs, or large telco companies. Are you sure?'
      },
      ipRangeDiscovery: 'IP-Range Discovery',
      ipRangeDiscoveryConfirm: {
        disable: {
          title: 'Disable IP-Range Discovery',
          confirm: 'Yes, disable',
          message:
            'Stops automatic discovery of assets inside netblocks / IP ranges for this customer. Assets found only through range-based discovery will become inactive on the next discovery job. Manually added assets are not affected.'
        },
        enable: {
          title: 'Enable IP-Range Discovery',
          confirm: 'Yes, enable',
          message:
            'Resumes automatic discovery of assets inside netblocks / IP ranges for this customer. This can reactivate many IPs and increase scan load on the next job, and for owners of large leased ranges may reintroduce false positives.'
        }
      }
    },
    helperAssetTypesMessage: 'Note: Please select at least one item',
    configurationOptions: {
      all_assets: 'All Assets',
      allWarningMessage: {
        underlinedWaring: 'Warning: ',
        underlinedNotReproducible: ' not reproducible.',
        firstPart: "This option may override the status of 'Monitored' assets, and is",
        secondPart: 'This option will only apply on the next discovery.'
      },
      unvalidated: 'Unvalidated Assets',
      no_change: 'No Status Change',
      change_to_unvalidated: 'Change to Unvalidated',
      irrelevant: 'Change to Irrelevant',
      in_scope: 'Monitored',
      pending: 'Pending Decision',
      out_of_scope: 'Not Monitored',
      domain: 'Domain',
      ip: 'IP',
      subdomain: 'Subdomain',
      google_cloud_storage: 'Google Cloud Storage',
      s3_bucket: 'S3 Bucket',
      azure_data_lake: 'Azure Data Lake',
      azure_storage_blob: 'Azure Storage Blob',
      all_types: 'All',
      successUpdatedAsmValidationConfigMessage: 'Configuration has been updated successfully.',
      failedToUpdateAsmValidationConfig: 'Failed to update the configuration.',
      precisionNumber: {
        integration_only: {
          title: 'Integration only',
          number: '100%',
          tooltipMessage: "Discovered by integrations into customer's systems."
        },
        high: {
          title: 'High',
          number: '>95%',
          tooltipMessage:
            'Discovered by methods which are prone to rare FPs, or do not have enough data to cross validate (e.g.: Domains with enrichment that supports discovery reason, IPs discovered by A record, etc.).'
        },
        very_high: {
          title: 'Very High',
          number: '>99%',
          tooltipMessage:
            'Assets discovered and cross-validated by methods of very high confidence (e.g.).Discovery by certificate, Netblock discovery, Domains hosted on netblocks, etc.).'
        },
        medium: {
          title: 'Medium',
          number: '>80%',
          tooltipMessage: 'Discovered by methods which have semi-reliable discovery.'
        }
      }
    },
    failedLoadCustomerConfiguration: 'Failed to load the configuration, please refresh the page and try again.',
    avs_configuration: {
      headerTitle: 'Active Exposure Validation allow list management',
      subTitle: 'Decide if the Scan will apply on None, Selected or All assets:',
      includedAssetsTooltip:
        'Choose specific assets permissible for Active Exposure validation. You can choose a wildcard domain e.g. “*domain.com”,  and all subdomains will be allowlisted. If there is a particular subdomain for exclusion, it can be added to the Blacklist.',
      excludedAssetsTooltip:
        'Choose specific assets denied for Active Exposure validation. You can choose a wildcard domain e.g. “*.domain.com ”,  and all subdomains will be blocklisted. If there is a particular subdomain for inclusion, it can be added to the allowlist.',
      includedAssets: 'Included Assets',
      excludedAssets: 'Excluded Assets',
      allMonitoredAssets: 'All Monitored Assets',
      agenticScan: 'Agentic Scan',
      agenticScanInfo:
        'Deploys autonomous AI agents that combine your attack surface data and threat intelligence to safely validate the exposures within your defined scope - reasoning about your assets the way a real attacker would. This helps you focus on the exposures that are genuinely exploitable, not just theoretically vulnerable.',
      agenticScanPrivacy:
        'As an AI-powered capability, results should be reviewed as part of your validation workflow and may not always be complete. For details on how your data is handled, see our %{link}.',
      agenticScanPrivacyLink: 'privacy policy'
    },
    ffIsNotTurnedOn: 'Feature Flag must be turned on.'
  },
  phishing_beacon_configuration: {
    intro: 'Please select a domain from the dropdown you want to be monitored by the Phishing Beacon:',
    title: 'Phishing Beacon Configuration',
    add_root_domain: 'Add to Monitoring',
    remove_root_domain: 'Remove from Monitoring',
    noOptions: 'No options',
    searching: 'Searching..',
    min_search_text_length: 'Enter at least 3 characters',
    invalid_url: 'Invalid URL',
    invalid_domain: 'Invalid domain value',
    provide:
      "Script for '%{domain}' was created. Copy and sent it to the customer.\n\nFew things to consider:\n" +
      '   1) The Phishing Beacon will be triggered only on web sites running on a different domain from what was selected.\n' +
      '   2) When using private IPs or localhost address as the website address, the Phishing Beacon will not be triggered.\n' +
      '   3) Make sure you have added the selected domain to the Phishing Beacon configuration before testing.',
    root_domain: 'Domain',
    error: 'Invalid domain value. Try a different value.',
    add_success: 'The domain has been added to the Phishing Beacon configuration.',
    add_error: 'Unable to add the domain to the Phishing Beacon configuration. Please try again later.',
    add_error_conflict: 'The domain is already monitored by the Phishing Beacon.',
    remove_success: 'The domain has been removed from the Phishing Beacon configuration.',
    remove_error: 'Unable to remove the domain from the Phishing Beacon configuration. Please try again later.',
    copy: 'Copy Script to Clipboard',
    copied: 'Copied to Clipboard',
    intro_table: 'The following table represents the domains which are already monitored by the Phishing Beacon:',
    table: {
      root_domain: 'Domain',
      created_date: 'Date Added',
      created_by: 'Added By',
      actions: 'Actions',
      copied: 'Script copied to Clipboard'
    },
    tooltips: {
      root_domain: 'The domain that is monitored by the Phishing Beacon',
      created_date: 'The data which the domain was added',
      actions:
        'From the actions below you can either remove a domain from Phishing Beacon monitoring and/or regenerate the Phishing Beacon script for it.',
      generate:
        'Generate the Phishing Beacon script for the corresponding domain. Script will be available in clipboard.'
    },
    modal: {
      ok: 'Remove',
      cancel: 'Cancel',
      title: 'Remove from monitoring',
      content: 'Are you sure you want to remove %{domain} from Phishing Beacon monitoring?'
    }
  },
  white_label_theme_settings: {
    title: 'White Label Configuration'
  },
  phishing_beacon_tester: {
    title: 'Phishing Beacon Tester',
    test: 'Test',
    hostname: 'Hostname',
    protected_domain: 'Protected Domain',
    client_ip: 'Client Ip',
    user_agent: 'User Agent',
    url: 'URL',
    timestamp: 'First Seen',
    test_place_holder: 'Enter the hostname of your test site',
    invalid_hostname_message: 'Hostname is invalid',
    error_message: 'Something went wrong, please try again later.',
    test_success_message:
      "Test succeeded! Found phishing beacon event that matches the hostname you've entered. See below for more info.",
    test_no_match_message:
      "If you've recently triggered the phishing beacon, please wait few moments before attempting again to allow the system to update.",
    tooltips: {
      hostname:
        'The hostname of the suspicious/test site where the Phishing Beacon triggered from. Hostname is a domain name or the unique name that identifies a website on the Internet. It is a part of the URL that specifies the address of a web page. Please note, hostname here can be any site which is not the protected domain nor localhost or private IP.',
      protected_domain: 'The domain that is monitored by the Phishing Beacon.',
      client_ip: 'The public client IP address of the device that visited the site (i.e. suspicious/test site).',
      user_agent: 'The user agent of the browser that was used by the client to enter the site.',
      timestamp: 'The first time a Phishing Beacon was received for this hostname since a while.',
      url: 'The last URL address of the suspicious/test site which the client visited.'
    }
  },
  mssp_consumption: {
    successfullyCreatedAndSortedCredits: 'Successfully created and stored purchased credit amount of a customer.',
    failedToCreateAndStoreCredits: 'Failed to create and store purchased credit amount of a customer.',
    failedToDownloadFile: 'Failed to download the file. Please try again later.',
    msspCredits: 'MSSP Credits',
    numOfCreditsPurchased: 'No. of Credits Purchased:',
    applyButton: 'Apply',
    creditConsumptionReportTitle: 'Credit Consumption report',
    downloadExcel: 'Download Excel',
    downloadingExcel: 'Downloading Excel...',
    failedLoadCustomerConfiguration: 'Failed to load the configuration, please refresh the page and try again.',
    waitUntilDownloadAgain: 'Generating a report will be available in %{timer} seconds'
  },
  msspList: {
    customerUpdated: 'Customer selection changed!'
  },
  'cyberint-news-page': {
    failedFetching: 'Failed to fetch news, Please try to refresh the page.',
    createdDateFilter: {
      from: 'From',
      to: 'To',
      apply: 'Apply',
      clear: 'Clear',
      allTime: 'All Time',
      pastWeek: 'Past Week',
      custom: 'Custom'
    }
  },
  'silent-env-insights-modal': {
    title: 'Consent',
    detected_issues: 'We have come across certain problems and/or misconfigurations within ',
    environment: ' environment',
    asm_failure: "We've encountered issues with the customer's last ASM discovery and scan",
    phishing_failure: "It appears that the customer's phishing configuration is not appropriately configured",
    failure: 'Please visit the Environment Insights page for more details.',
    ok: 'Show me Environment Insights'
  },
  socket_events: {
    runnning_oper: {
      tiAssetSubmissions: 'Intelligence Collection Assets Configuration'
    },
    snackbar: {
      submit_assets: {
        success: 'Asset submission completed',
        failure: 'Asset submission failed',
        in_progress: 'Asset submission is in progress'
      },
      run_asm_discovery: {
        success: 'Running ASM discovery',
        failure: 'Failed to run ASM discovery'
      },
      reclaim_resources: {
        success: 'Reclaimed %{amount} %{resource} from %{child}',
        failure: 'Failed to reclaim %{amount} %{resource} from %{child}'
      },
      download_report: {
        vendor: {
          report_for: 'Vendor report for',
          is_ready: 'is ready.',
          click: 'Click',
          here: 'here',
          to_download: 'to download',
          failed_to_download: 'Failed to download %{title} vendor report',
          in_progress: 'vendor report generation has started'
        },
        tl_ai: {
          title: 'Threat Landscape report',
          report_ready: 'Threat Landscape report is ready.',
          failed_to_download: 'Failed to download Threat Landscape report',
          in_progress: 'Threat Landscape report generation has started'
        },
        ti_brief: {
          daily_brief: 'Threat Intelligence Daily Brief',
          weekly_brief: 'Threat Intelligence Weekly Brief',
          report_ready: '%{brief_title} is ready.',
          failed_to_download: 'Failed to generate %{brief_title}. Please try again.',
          in_progress: "%{brief_title} generation has started. You will be notified when it's ready."
        }
      }
    },
    bg_operations_popup: {
      download_report: {
        vendor_report: 'Vendor report:'
      }
    }
  },
  customer_updated_msg: `Tenant details for %{tenantName} have been updated. Click to apply changes.`,
  feedback: {
    title: 'Our 1st Community Webinar is this Thursday, Jan 29. Not registered?',
    link: 'Register'
  },
  survey: {
    title: 'Complete our 5-minute survey, your feedback helps us improve! 🎉',
    clickhere: 'Click here'
  },
  new_support_process: {
    title: 'New Support Portal Live!',
    clickhere: 'Contact Admin',
    goToPortal: 'Go to Portal'
  }
};
